    // src/pages/Plaatsingen.js
    // vPL-075
// - Start vanuit Opdrachten hersteld: ?new=1&order_id=... opent direct een nieuwe Plaatsing en neemt Opdracht-defaults over
// - Fallback via staffiq_source_hrm_order_id toegevoegd
// vPL-074
// - Opdracht gekoppeld aan Plaatsingen; defaults worden alleen in lege velden ingevuld
// - Opdracht toegevoegd boven Relatie en in grid tussen Status en CAO
// vPL-073
// - Documentsets: optioneel onderdeel zonder gekoppeld document toont Optioneel in plaats van Gereed
// vPL-072
// - Documentsets: gestarte set kan worden verwijderd; voortgang en Actiecentrum worden daarna opnieuw geladen
// vPL-071
// - Documentsets-knop toont direct de voortgang van de gestarte set(s), bijvoorbeeld 3/3 ✓
// - Documentsetstatus wordt bij selectie/vernieuwen van een plaatsing automatisch bijgewerkt
// vPL-070
    // - Documentsets: bestaand document kiezen of nieuw uploaden via Documenten en automatisch terugkoppelen
    // - Terugkeer opent dezelfde plaatsing en documentset opnieuw
    // vPL-069
    // - Documentsets: huidig plaatsingsdossier en personeelsdossier worden afzonderlijk geladen
    // - Hergebruikte personeelsdocumenten zijn zichtbaar in de checklist
    // - Ontbrekend document kan rechtstreeks vanuit de set in Documenten worden toegevoegd
    // vPL-068
    // - Documentsets gekoppeld aan Plaatsingen
    // - Knoppenvolgorde Status / opvolging aangepast; Documentsets naast Starten
    // vPL-067
    // - Rubriek Plaats verwijderd uit rechterkolom; Regio blijft voor matching
    // - Plaats en Regio worden niet meer dubbel achter het bezoekadres op bevestigingen gezet
    // vPL-066
    // - Locatie/bezoekadres uitgebreid; bezoekadres relatie automatisch ingevuld wanneer vorige stap leeg is
    // - Contact op locatie en Aanmeldprocedure toegevoegd en opgenomen in plaatsingsbevestigingen
    // - Opzegtermijn toegevoegd onder Einddatum, overgenomen vanuit Aanvraag/Vacature en opgenomen in bevestigingen
    // vPL-064
    // - Reisuren label gewijzigd naar Reisuren per dag
    // - Reiskosteneenheid per km / per dag wordt nu overgenomen vanuit Aanvraag/Vacature
    // vPL-063
    // - Reisuren toegevoegd en overgenomen vanuit Aanvraag/Vacature
    // vPL-062
    // - Plaatsingsbevestigingen gebruiken uitsluitend hun eigen HRM-documentinstellingen per bedrijfscode
    // - Lege Adresregel 2 valt niet meer terug op oude offerte/factuur-testgegevens
    // vPL-059
    // - Label Plaatsingsnummer gewijzigd in Plaatsingsreferentie
    // vPL-058
    // - Vacature-route volledig gekoppeld: Plaatsing bewaart vacature-id en gebruikt actuele vacaturegegevens met aanvraag als fallback
    // - Vacature kan application_id aanleveren wanneer deze niet apart in de URL staat
    // vPL-055
    // - Bevestigingen afgestemd op Vast/Tijdelijk versus ZZP/Doorleen; inkooptarief nooit naar klant
    // - Inzetvorm / inkooptarief / ervaring / leverancier structureel in Plaatsingen
    // - Matching Personeel: tijdelijke wijzigingen in functie/tarieven worden overgenomen in nieuwe plaatsing
    // - Fix voorbeeld klant/kandidaat: juiste decimaalformatter voor reiskosten
    // - Plaatsingsbevestigingen verwerken vervoer en gescheiden reiskosten voor kandidaat/klant
    // - Reiskostenvergoeding en Reiskosten klant exact gelijk opgemaakt
    // - Layout tarieven/reiskosten verfijnd: vergoeding onder uurloon en verkoopvelden uitgelijnd
    // - Vervoer/reiskosten uitgebreid: medewerkervergoeding en klantdoorbelasting apart
    // - Ochtend- en middagplanning toegevoegd; minimaal één dagdeel verplicht
    // - Documentinhoud plaatsingsbevestiging klant instelbaar per bedrijfscode
    // - Loon-, tarief- en overige regels afzonderlijk tonen of verbergen
    // - Plaatsingsbevestiging klant volledig gekoppeld aan HRM-instellingen per bedrijfscode
    // - Document, e-mail, WhatsApp en akkoordverklaring gebruiken dezelfde HRM-layoutinstellingen
    // - Smartphone: na selectie van een regel wordt de invoerkolom bovenaan in beeld gezet
    // - Procesknoppen Plaatsingen altijd zichtbaar met slimme uitgrijslogica
    // - Vernieuw maakt de rechterkolom leeg en zet procesknoppen uit
    // - Handmatige Klant akkoord / Kandidaat akk knoppen verwijderd
    // - Procesknoppen opnieuw gekleurd: Voorstellen/Bevestigen eigen kleur, akkoord groen
    // - Status handmatig terug naar Concept/Voorgesteld zet processtatussen ook terug
    // - Akkoord-knoppen worden uitgegrijsd zodra klant/kandidaat akkoord is
    // - Akkoordkeuze met klikbare knoppen + keuze 4: wel akkoord, geen WhatsApp/E-mail
    // - Bevestigen/Akkoord-knoppen worden uitgegrijsd na opslaan of na starten
    // - Mailknoppen verwijderd; digitaal akkoord gebruikt WhatsApp/E-mail keuze
    // - Losse vinkjes Kandidaat/Klant bevestigd verwijderd
    // - Bevestigen-knop verwijderd; klant/kandidaat akkoord zet status automatisch naar Bevestigd als beide akkoord zijn
    // - WhatsApp-klaar scherm heeft nu duidelijke terugknop naar Plaatsingen
    // - Plaatsingsbevestigingen: duidelijke meldingen bij Opslaan/Mail
    // - Namen op plaatsingsbevestiging als normale naam i.p.v. zoeknaam
    // - Digitale akkoordmodule voor plaatsingsbevestiging klant/kandidaat
    //
    // StaffIQ HRM - Plaatsingen
    // Opzet gelijk aan Aanvragen / Vacatures:
    // - Links/boven: zoeken + knoppen
    // - Midden: overzicht met sortering en kolomfilters
    // - Rechts: detailkaart

    import React, { useEffect, useMemo, useRef, useState } from "react";
    import useVoiceCommands from "../components/useVoiceCommands";
    import HelpButton from "../components/HelpButton";

    const VERSION = "vPL-075";

    const emptyHrmPlacementCustomerSettings = {
      document_title: "Plaatsingsbevestiging klant",
      company_name: "",
      company_address_1: "",
      company_address_2: "",
      company_postcode: "",
      company_city: "",
      company_country: "",
      company_email: "",
      company_website: "",
      company_phone: "",
      company_kvk: "",
      company_vat: "",
      company_iban: "",
      company_g_iban: "",
      logo_url: "",
      intro_text: "Hierbij bevestigen wij de plaatsing van {kandidaat} bij {relatie}.",
      footer_text: "Plaatsingsbevestiging automatisch gegenereerd vanuit StaffIQ.",
      email_subject: "Plaatsingsbevestiging {document_nummer} ter akkoord",
      email_text: "",
      whatsapp_text: "",
      approval_text: "Ik ben bevoegd om namens deze organisatie akkoord te geven en ik ga akkoord met deze plaatsingsbevestiging.",
      approved_page_text: "Dank u. Uw akkoord op de plaatsingsbevestiging is ontvangen en geregistreerd.",
      rejected_page_text: "Uw keuze om niet akkoord te gaan met de plaatsingsbevestiging is ontvangen en geregistreerd.",

      // Documentinhoud plaatsingsbevestiging klant
      show_function: true,
      show_relation: true,
      show_contact: true,
      show_candidate: true,
      show_start_date: true,
      show_end_date: true,
      show_notice_period: true,
      show_hours_per_week: true,
      show_weekends: true,
      show_schedule: true,
      show_location: true,
      show_location_contact: true,
      show_registration_procedure: true,
      show_employment_type: false,
      show_cao: true,
      show_wage_period: false,
      show_hourly_wage: false,
      show_invoice_period: true,
      show_sales_rate: true,
      show_factor: false,
      show_transport: true,
      show_customer_travel_costs: true,
      show_travel_costs: true,
      show_allowances: true,
      show_invoice_agreement: true,
      show_external_note: true,
    };

    const emptyHrmPlacementCandidateSettings = {
      document_title: "Plaatsingsbevestiging kandidaat",
      company_name: "",
      company_address_1: "",
      company_address_2: "",
      company_postcode: "",
      company_city: "",
      company_country: "",
      company_email: "",
      company_website: "",
      company_phone: "",
      company_kvk: "",
      company_vat: "",
      company_iban: "",
      company_g_iban: "",
      logo_url: "",
      intro_text: "Hierbij bevestigen wij jouw plaatsing bij {relatie}.",
      footer_text: "Plaatsingsbevestiging automatisch gegenereerd vanuit StaffIQ.",
      email_subject: "Plaatsingsbevestiging {document_nummer} ter akkoord",
      email_text: "",
      whatsapp_text: "",
      approval_text: "Ik ga akkoord met deze plaatsingsbevestiging.",
      approved_page_text: "Dank je. Jouw akkoord op de plaatsingsbevestiging is ontvangen en geregistreerd.",
      rejected_page_text: "Jouw keuze om niet akkoord te gaan met de plaatsingsbevestiging is ontvangen en geregistreerd.",

      // Documentinhoud plaatsingsbevestiging kandidaat
      show_function: true,
      show_relation: true,
      show_contact: true,
      show_candidate: true,
      show_start_date: true,
      show_end_date: true,
      show_notice_period: true,
      show_hours_per_week: true,
      show_weekends: true,
      show_schedule: true,
      show_location: true,
      show_location_contact: true,
      show_registration_procedure: true,
      show_employment_type: false,
      show_cao: true,
      show_wage_period: true,
      show_hourly_wage: true,
      show_transport: true,
      show_travel_costs: true,
      show_allowances: true,
      show_external_note: true,
    };

    function replacePlacementVariables(template, values = {}) {
      let output = String(template || "");

      Object.entries(values).forEach(([key, value]) => {
        output = output.split(`{${key}}`).join(String(value ?? ""));
      });

      return output;
    }

    const buildUrl = (u) =>
      u.startsWith("http") ? u : `${u.startsWith("/") ? u : `/${u}`}`;

    function getParam(name) {
      try {
        const url = new URL(window.location.href);
        return url.searchParams.get(name) || "";
      } catch {
        return "";
      }
    }

    function norm(s) {
      return String(s || "")
        .toLowerCase()
        .trim()
        .replace(/[，、]/g, ",")
        .replace(/[“”]/g, '"')
        .replace(/[‘’]/g, "'")
        .replace(/[;:!?]/g, "")
        .replace(/\s+/g, " ");
    }

    function safeTrim(s) {
      return String(s || "").trim();
    }

    function normalizeTravelCostsUnitForPlacement(value) {
      return String(value || "").trim().toLowerCase() === "day" ? "day" : "km";
    }

    function isEmptyWord(t) {
      const x = norm(t);
      return x === "geen" || x === "blanco" || x === "leeg" || x === "null";
    }

    function uniqSorted(arr) {
      const set = new Set((arr || []).map((x) => String(x).trim()).filter(Boolean));
      return Array.from(set).sort((a, b) => a.localeCompare(b, "nl"));
    }

    function isoDate(s) {
      const t = String(s || "").slice(0, 10);
      return /^\d{4}-\d{2}-\d{2}$/.test(t) ? t : "";
    }

    function formatDateNL(iso) {
      const s = String(iso || "").slice(0, 10);
      if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return "";
      const [y, m, d] = s.split("-");
      return `${d}-${m}-${y}`;
    }

    function parseDecimal(v) {
      const raw = String(v ?? "")
        .trim()
        .replace(/\s/g, "")
        .replace(/[^0-9,.-]/g, "");

      if (!raw) return 0;

      let cleaned = raw;

      if (cleaned.includes(",")) {
        // Nederlandse invoer: 2,35 of 2.350,75
        cleaned = cleaned.replace(/\./g, "").replace(",", ".");
      } else {
        // Engelse/database-notatie: 2.35 moet 2.35 blijven.
        // Alleen meerdere punten zien we als duizendtallen: 2.350.750 -> 2350750
        const dotCount = (cleaned.match(/\./g) || []).length;
        if (dotCount > 1) cleaned = cleaned.replace(/\./g, "");
      }

      const n = Number(cleaned);
      return Number.isFinite(n) ? n : 0;
    }

    function decimalInput(v, decimals = 2) {
      if (v === null || v === undefined || v === "") return "";

      const n = parseDecimal(v);
      if (!Number.isFinite(n)) return "";

      return n.toLocaleString("nl-NL", {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      });
    }

    function cleanDecimalInputValue(v) {
      return String(v || "").replace(/[^0-9,.-]/g, "");
    }

    function formatDecimalInputValue(v, decimals = 2) {
      const raw = String(v || "").trim();
      if (!raw) return "";
      const n = parseDecimal(raw);
      if (!Number.isFinite(n)) return raw;
      return n.toLocaleString("nl-NL", {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      });
    }

    function parseActiveValue(it) {
      const raw = it?.active ?? it?.is_active ?? it?.isActive ?? it?.actief;
      if (raw === undefined || raw === null || raw === "") return null;
      if (raw === true) return true;
      if (raw === false) return false;
      const s = String(raw).toLowerCase().trim();
      if (raw === 1 || s === "1" || s === "true" || s === "yes" || s === "y" || s === "j" || s === "ja" || s === "aan" || s === "on") return true;
      if (raw === 0 || s === "0" || s === "false" || s === "no" || s === "n" || s === "nee" || s === "uit" || s === "off") return false;
      return !!raw;
    }

    function boolToJaNee(v) {
      return v === true ? "j" : "n";
    }

    function getSelectedCompanyCodeIdsHeader() {
      return (
        sessionStorage.getItem("selectedCompanyCodeIds") ||
        localStorage.getItem("selectedCompanyCodeIds") ||
        sessionStorage.getItem("company_code_ids") ||
        localStorage.getItem("company_code_ids") ||
        ""
      );
    }

    async function tryFetchJson(urls, options = {}) {
      const token =
        sessionStorage.getItem("token") ||
        localStorage.getItem("token") ||
        "";

      const tenant =
        sessionStorage.getItem("tenant") ||
        localStorage.getItem("tenant") ||
        "demo";

      let role = "user";
      try {
        role =
          JSON.parse(
            sessionStorage.getItem("user") ||
            localStorage.getItem("user") ||
            "{}"
          )?.role || "user";
      } catch {}

      let lastErr = null;

      for (const url of urls) {
        try {
          const headers = {
            ...(options.headers || {}),
            Authorization: token ? `Bearer ${token}` : undefined,
            "x-tenant": tenant,
            "x-role": role,
            "x-company-code-ids": getSelectedCompanyCodeIdsHeader() || undefined,
          };

          Object.keys(headers).forEach(
            (k) => headers[k] === undefined && delete headers[k]
          );

          const res = await fetch(buildUrl(url), {
            ...options,
            headers,
          });

          if (!res.ok) {
            const raw = await res.text();
            let msg = `${url} (${res.status})`;

            try {
              const data = raw ? JSON.parse(raw) : null;
              msg = data?.error || data?.message || raw || msg;
            } catch {
              msg = raw || msg;
            }

            throw new Error(msg);
          }

          if (res.status === 204) return null;
          const text = await res.text();
          if (!text) return null;

          try {
            return JSON.parse(text);
          } catch {
            return text;
          }
        } catch (err) {
          lastErr = err;
        }
      }

      throw lastErr;
    }

    function stopGridClick(e) {
      try {
        e.preventDefault();
        e.stopPropagation();
      } catch {}
    }

    function emptyFormToday() {
      return {
        id: null,
        placement_date: new Date().toISOString().slice(0, 10),
        placement_number: "",
        status: "Concept",
        application_id: "",
        vacancy_id: "",
        order_id: "",
        organisation_id: "",
        contact_id: "",
        company_code_id: "",
        personnel_id: "",
        job_title: "",
        start_date: "",
        end_date: "",
        notice_period: "",
        hours_per_week: "",
        plan_morning: true,
        plan_afternoon: true,
        plan_weekends: false,
        schedule_text: "",
        location: "",
        location_contact: "",
        registration_procedure: "",
        place: "",
        region: "",
        cao: "",
        wage_period: "week",
        invoice_period: "week",
        factor: "",
        hourly_wage: "",
        employment_type: "Vast",
        purchase_rate: "",
        rate_level: "",
        source_organisation_id: "",
        supplier_name: "",
        sales_rate: "",
        travel_costs: "",
        travel_hours_amount: "",
        travel_costs_unit: "km",
        own_transport: false,
        company_transport: false,
        charge_travel_costs: false,
        charge_travel_costs_unit: "km",
        charge_travel_costs_amount: "",
        allowances: "",
        invoice_agreement: "",
        candidate_status: "Concept",
        customer_status: "Concept",
        customer_confirmed: false,
        candidate_confirmed: false,
        internal_note: "",
        external_note: "",
        remarks: "",
        active: true,
      };
    }


    function organisationVisitAddressText(org = {}) {
      const name = safeTrim(org?.name || org?.naam || org?.bedrijfsnaam || org?.search_name || org?.zoeknaam || "");
      const street = safeTrim(org?.visit_street || org?.bezoek_straat || "");
      const houseNumber = safeTrim(org?.visit_house_number || org?.bezoek_huisnummer || "");
      const addition = safeTrim(org?.visit_addition || org?.bezoek_toevoeging || "");
      const postcode = safeTrim(org?.visit_postcode || org?.bezoek_postcode || "");
      const city = safeTrim(org?.visit_city || org?.bezoek_plaats || "");
      const country = safeTrim(org?.visit_country || org?.bezoek_land || "");
      const streetLine = [street, houseNumber, addition].filter(Boolean).join(" ");
      const cityLine = [postcode, city].filter(Boolean).join(" ");
      return [name, streetLine, cityLine, country].filter(Boolean).join("\n");
    }

    function organisationVisitPlace(org = {}) {
      return safeTrim(org?.visit_city || org?.bezoek_plaats || "");
    }

    function organisationVisitRegion(org = {}) {
      return safeTrim(org?.visit_region || org?.region || org?.regio || "");
    }

    function pickOrgName(o) {
      return safeTrim(o?.search_name || o?.zoeknaam || o?.name || o?.naam || o?.bedrijfsnaam || "");
    }

    function orgIdOf(o) {
      return o?.id ?? o?.organisation_id ?? o?.organisatie_id ?? "";
    }

    function orgNameFromList(list, id, fallback = "") {
      const wanted = String(id || "");
      const found = (list || []).find((o) => String(orgIdOf(o)) === wanted);
      return pickOrgName(found) || fallback || "";
    }

    function pickCompanyCodeName(row) {
      return safeTrim(row?.company_code_name || row?.company_code_display_name || row?.company_code || row?.bedrijfscode || "");
    }

    function orgCompanyCodeNameFromList(list, id, fallback = "") {
      const wanted = String(id || "");
      const found = (list || []).find((o) => String(orgIdOf(o)) === wanted);
      return pickCompanyCodeName(found) || fallback || "";
    }

    function pickContactName(c) {
      const fn = safeTrim(c?.first_name || c?.voornaam || "");
      const ln = safeTrim(c?.last_name || c?.achternaam || "");
      const full = safeTrim(c?.full_name || c?.naam || "");
      return safeTrim(c?.search_name || c?.display_name || (ln && fn ? `${ln}, ${fn}` : "") || full || fn || "");
    }

    function contactIdOf(c) {
      return c?.id ?? c?.contact_id ?? "";
    }

    function personnelName(p) {
      const first = safeTrim(p?.first_name || "");
      const prefix = safeTrim(p?.name_prefix || "");
      const last = safeTrim(p?.last_name || "");
      return safeTrim(p?.search_name || [last, [first, prefix].filter(Boolean).join(" ")].filter(Boolean).join(", ") || [first, prefix, last].filter(Boolean).join(" "));
    }

    function displayPersonName(p, fallback = "") {
      const first = safeTrim(p?.first_name || "");
      const prefix = safeTrim(p?.name_prefix || "");
      const last = safeTrim(p?.last_name || "");
      const normal = [first, prefix, last].filter(Boolean).join(" ").trim();
      return safeTrim(normal || fallback || p?.full_name || p?.name || p?.search_name || "");
    }

    function displayContactName(c, fallback = "") {
      const first = safeTrim(c?.first_name || c?.voornaam || "");
      const prefix = safeTrim(c?.name_prefix || c?.tussenvoegsel || c?.tussenvoegsels || "");
      const last = safeTrim(c?.last_name || c?.achternaam || "");
      const normal = [first, prefix, last].filter(Boolean).join(" ").trim();
      return safeTrim(normal || fallback || c?.full_name || c?.naam || c?.search_name || c?.display_name || "");
    }

    function normalizePlacement(raw = {}) {
      return {
        ...raw,
        id: raw.id ?? null,
        placement_date: isoDate(raw.placement_date),
        start_date: isoDate(raw.start_date),
        end_date: isoDate(raw.end_date),
        notice_period: raw.notice_period ?? "",
        location_contact: raw.location_contact ?? "",
        registration_procedure: raw.registration_procedure ?? "",
        application_id: raw.application_id ?? "",
        vacancy_id: raw.vacancy_id ?? "",
        order_id: raw.order_id ?? raw.hrm_order_id ?? "",
        organisation_id: raw.organisation_id ?? "",
        contact_id: raw.contact_id ?? "",
        company_code_id: raw.company_code_id ?? "",
        company_code: raw.company_code ?? "",
        company_code_name: raw.company_code_name ?? "",
        personnel_id: raw.personnel_id ?? "",
        hours_per_week: decimalInput(raw.hours_per_week, 2),
        plan_morning: raw.plan_morning !== false,
        plan_afternoon: raw.plan_afternoon !== false,
        plan_weekends: raw.plan_weekends === true,
        factor: decimalInput(raw.factor),
        hourly_wage: decimalInput(raw.hourly_wage),
        employment_type: ["Vast", "Tijdelijk", "ZZP", "Doorleen"].includes(raw.employment_type) ? raw.employment_type : "Vast",
        purchase_rate: decimalInput(raw.purchase_rate),
        rate_level: raw.rate_level ?? "",
        source_organisation_id: raw.source_organisation_id ?? "",
        supplier_name: raw.supplier_name ?? "",
        sales_rate: decimalInput(raw.sales_rate),
        travel_costs: decimalInput(raw.travel_costs),
        travel_hours_amount: decimalInput(raw.travel_hours_amount),
        travel_costs_unit: raw.travel_costs_unit === "day" ? "day" : "km",
        own_transport: raw.own_transport === true,
        company_transport: raw.company_transport === true,
        charge_travel_costs: raw.charge_travel_costs === true,
        charge_travel_costs_unit: raw.charge_travel_costs_unit === "day" ? "day" : "km",
        charge_travel_costs_amount: decimalInput(raw.charge_travel_costs_amount),
        customer_confirmed: raw.customer_confirmed === true,
        candidate_confirmed: raw.candidate_confirmed === true,
        active: parseActiveValue(raw) !== false,
      };
    }


    function Field({ label, children, labelMinHeight = 0 }) {
      return (
        <div style={{ marginBottom: 9 }}>
          <label
            style={{
              display: "block",
              fontSize: 12,
              color: "#555",
              marginBottom: 3,
              minHeight: labelMinHeight || undefined,
            }}
          >
            {label}
          </label>
          {children}
        </div>
      );
    }

    export default function Plaatsingen() {
      const rawUser =
        sessionStorage.getItem("user") ||
        localStorage.getItem("user") ||
        "";

      let role = "user";

      try {
        role = JSON.parse(rawUser || "{}")?.role || "user";
      } catch {}

      const isReadonlyRole = String(role || "").toLowerCase() === "readonly";

      const [items, setItems] = useState([]);
      const [applications, setApplications] = useState([]);
      const [vacancies, setVacancies] = useState([]);
      const [orders, setOrders] = useState([]);
      const [organisations, setOrganisations] = useState([]);
      const [contacts, setContacts] = useState([]);
      const [personnel, setPersonnel] = useState([]);
      const [invoiceSettings, setInvoiceSettings] = useState({});
      const [hrmPlacementCustomerSettings, setHrmPlacementCustomerSettings] = useState(emptyHrmPlacementCustomerSettings);
      const [hrmPlacementCandidateSettings, setHrmPlacementCandidateSettings] = useState(emptyHrmPlacementCandidateSettings);
      const [selectedId, setSelectedId] = useState(null);
      const [form, setForm] = useState(emptyFormToday());
      const [listIndex, setListIndex] = useState(-1);
      const [loading, setLoading] = useState(false);
      const [error, setError] = useState(null);
      const [saveError, setSaveError] = useState(null);
      const [flash, setFlash] = useState("");
      const [sendingApproval, setSendingApproval] = useState(false);
      const [lastApprovalInfo, setLastApprovalInfo] = useState(null);
      const [savedConfirmations, setSavedConfirmations] = useState({ customer: false, candidate: false });
      const [speechInfo, setSpeechInfo] = useState("");
      const [documentSetsOpen, setDocumentSetsOpen] = useState(false);
      const [documentSets, setDocumentSets] = useState([]);
      const [documentSetInstances, setDocumentSetInstances] = useState([]);
      const [placementDocuments, setPlacementDocuments] = useState([]);
      const [personnelDocumentsForSet, setPersonnelDocumentsForSet] = useState([]);
      const [documentSetsBusy, setDocumentSetsBusy] = useState(false);
      const [documentSetsError, setDocumentSetsError] = useState("");
      const [documentSetSummary, setDocumentSetSummary] = useState({ completed: 0, total: 0, complete: false, started: false });

      // Grote editor voor Opmerking intern / extern.
      // Waarde is "" | "internal_note" | "external_note".
      const [noteEditor, setNoteEditor] = useState("");

      const [q, setQ] = useState(getParam("q"));
      const [organisationFilterId, setOrganisationFilterId] = useState(getParam("organisation_id"));

      const EMPTY_VAL = "__EMPTY__";
      const [dateFilter, setDateFilter] = useState("");
      const [relationFilter, setRelationFilter] = useState("");
      const [personFilter, setPersonFilter] = useState("");
      const [functionFilter, setFunctionFilter] = useState("");
      const [statusFilter, setStatusFilter] = useState("");
      const [orderFilter, setOrderFilter] = useState("");
      const [caoFilter, setCaoFilter] = useState("");
      const [companyCodeFilter, setCompanyCodeFilter] = useState("");
      const [activeFilter, setActiveFilter] = useState("j");

      const [mode, setMode] = useState("search");
      const isFormLocked = isReadonlyRole || mode !== "form";
      const [sort, setSort] = useState({ key: "date", dir: "desc" });

      const pageTopRef = useRef(null);
      const searchRef = useRef(null);
      const rowRefs = useRef([]);
      const rightScrollRef = useRef(null);
      const autoPlacementStartedRef = useRef(false);
      const orderLaunchHandledRef = useRef(false);

      const dateRef = useRef(null);
      const numberRef = useRef(null);
      const applicationRef = useRef(null);
      const vacancyRef = useRef(null);
      const orderRef = useRef(null);
      const relationRef = useRef(null);
      const contactRef = useRef(null);
      const personnelRef = useRef(null);
      const functionRef = useRef(null);
      const statusRef = useRef(null);
      const startDateRef = useRef(null);
      const endDateRef = useRef(null);
      const noticePeriodRef = useRef(null);
      const hoursRef = useRef(null);
      const morningRef = useRef(null);
      const afternoonRef = useRef(null);
      const weekendRef = useRef(null);
      const scheduleRef = useRef(null);
      const locationRef = useRef(null);
      const locationContactRef = useRef(null);
      const registrationProcedureRef = useRef(null);
      const regionRef = useRef(null);
      const caoRef = useRef(null);
      const wagePeriodRef = useRef(null);
      const invoicePeriodRef = useRef(null);
      const factorRef = useRef(null);
      const employmentTypeRef = useRef(null);
      const wageRef = useRef(null);
      const purchaseRateRef = useRef(null);
      const salesRateRef = useRef(null);
      const travelCostsRef = useRef(null);
      const travelHoursAmountRef = useRef(null);
      const travelCostsUnitRef = useRef(null);
      const ownTransportRef = useRef(null);
      const companyTransportRef = useRef(null);
      const chargeTravelCostsRef = useRef(null);
      const chargeTravelCostsUnitRef = useRef(null);
      const chargeTravelCostsAmountRef = useRef(null);
      const allowancesRef = useRef(null);
      const invoiceAgreementRef = useRef(null);
      const candidateStatusRef = useRef(null);
      const customerStatusRef = useRef(null);
      const internalNoteRef = useRef(null);
      const externalNoteRef = useRef(null);
      const internalNoteBigRef = useRef(null);
      const externalNoteBigRef = useRef(null);
      const ignoreNextNoteFocusRef = useRef("");

      function openNoteEditor(key) {
        if (isFormLocked) return;

        setNoteEditor(key);

        setTimeout(() => {
          try {
            const ref = key === "internal_note" ? internalNoteBigRef : externalNoteBigRef;
            const el = ref.current;
            if (!el) return;

            el.focus?.({ preventScroll: true });
            const len = String(el.value || "").length;
            el.setSelectionRange?.(len, len);
          } catch {}
        }, 0);
      }

      function closeNoteEditor() {
        const key = noteEditor;

        // Voorkom dat focus op het kleine veld de editor direct opnieuw opent.
        ignoreNextNoteFocusRef.current = key;
        setNoteEditor("");

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            try {
              const panel = rightScrollRef.current;
              const ref = key === "internal_note" ? internalNoteRef : externalNoteRef;
              const el = ref.current;

              if (!el) return;

              try {
                el.focus?.({ preventScroll: true });
              } catch {
                el.focus?.();
              }

              // Terug = betreffende kleine veld onderaan in de rechterkolom.
              if (panel && window.innerWidth > 768) {
                const panelRect = panel.getBoundingClientRect();
                const elRect = el.getBoundingClientRect();
                const currentTop = panel.scrollTop;
                const relativeBottom = elRect.bottom - panelRect.top + currentTop;
                const paddingBottom = 10;

                panel.scrollTop = Math.max(
                  0,
                  relativeBottom - panel.clientHeight + paddingBottom
                );
              } else {
                el.scrollIntoView?.({
                  behavior: "auto",
                  block: "end",
                  inline: "nearest",
                });
              }
            } catch {}
          });
        });
      }

      const focusOrderRefs = [
        dateRef,
        numberRef,
        applicationRef,
        vacancyRef,
        orderRef,
        relationRef,
        contactRef,
        personnelRef,
        functionRef,
        statusRef,
        startDateRef,
        endDateRef,
        noticePeriodRef,
        hoursRef,
        morningRef,
        afternoonRef,
        weekendRef,
        scheduleRef,
        locationRef,
        locationContactRef,
        registrationProcedureRef,
        regionRef,
        caoRef,
        wagePeriodRef,
        invoicePeriodRef,
        factorRef,
        employmentTypeRef,
        wageRef,
        purchaseRateRef,
        travelCostsRef,
        travelHoursAmountRef,
        travelCostsUnitRef,
        ownTransportRef,
        companyTransportRef,
        salesRateRef,
        chargeTravelCostsRef,
        chargeTravelCostsAmountRef,
        chargeTravelCostsUnitRef,
        allowancesRef,
        invoiceAgreementRef,
        candidateStatusRef,
        customerStatusRef,
        internalNoteRef,
        externalNoteRef,
      ];

      async function loadOrders() {
        try {
          const data = await tryFetchJson(["/api/hrm-orders"]);
          setOrders(Array.isArray(data) ? data : []);
        } catch {
          setOrders([]);
        }
      }

      function orderReference(item = {}) {
        const wanted = String(item?.order_id ?? item?.hrm_order_id ?? "");
        const found = (orders || []).find((o) => String(o?.id ?? "") === wanted);
        return safeTrim(found?.order_reference || item?.order_reference || "");
      }

      function applyOrderDefaults(orderId) {
        const selectedOrder = (orders || []).find((o) => String(o?.id ?? "") === String(orderId || ""));
        setForm((prev) => {
          if (!selectedOrder) return { ...prev, order_id: orderId || "" };
          const organisationId = selectedOrder.organisation_id ? String(selectedOrder.organisation_id) : "";
          const orderOrg = (organisations || []).find((o) => String(orgIdOf(o)) === organisationId);
          return {
            ...prev,
            order_id: String(selectedOrder.id || ""),
            organisation_id: safeTrim(prev.organisation_id) || organisationId,
            contact_id: safeTrim(prev.contact_id) || (selectedOrder.contact_id ? String(selectedOrder.contact_id) : ""),
            company_code_id: safeTrim(prev.company_code_id) || (selectedOrder.company_code_id ? String(selectedOrder.company_code_id) : ""),
            company_code_name: safeTrim(prev.company_code_name) || safeTrim(selectedOrder.company_code_name),
            location: safeTrim(prev.location) || safeTrim(selectedOrder.location) || organisationVisitAddressText(orderOrg),
            place: safeTrim(prev.place) || organisationVisitPlace(orderOrg),
            region: safeTrim(prev.region) || organisationVisitRegion(orderOrg),
            start_date: safeTrim(prev.start_date) || isoDate(selectedOrder.start_date),
            end_date: safeTrim(prev.end_date) || isoDate(selectedOrder.end_date),
            cao: safeTrim(prev.cao) || safeTrim(selectedOrder.cao),
          };
        });
      }

      async function loadOrganisations() {
        try {
          const data = await tryFetchJson(["/api/organisations"]);
          setOrganisations(Array.isArray(data) ? data : []);
        } catch {
          setOrganisations([]);
        }
      }

      async function loadApplications() {
        try {
          const data = await tryFetchJson(["/api/applications", "/api/aanvragen"]);
          setApplications(Array.isArray(data) ? data : []);
        } catch {
          setApplications([]);
        }
      }

      async function loadVacancies() {
        try {
          const data = await tryFetchJson(["/api/vacancies", "/api/vacatures"]);
          setVacancies(Array.isArray(data) ? data : []);
        } catch {
          setVacancies([]);
        }
      }

      async function loadPersonnel() {
        try {
          const data = await tryFetchJson(["/api/personnel"]);
          setPersonnel(Array.isArray(data) ? data : []);
        } catch {
          setPersonnel([]);
        }
      }

      async function loadInvoiceSettings() {
        try {
          const data = await tryFetchJson(["/api/invoice-settings"]);
          setInvoiceSettings(data && typeof data === "object" ? data : {});
        } catch {
          setInvoiceSettings({});
        }
      }

      async function loadHrmPlacementCustomerSettings(companyCodeId = "") {
        try {
          const qs = companyCodeId
            ? `?company_code_id=${encodeURIComponent(companyCodeId)}`
            : "";

          const data = await tryFetchJson([
            `/api/company-section-settings/hrm_placement_customer${qs}`,
          ]);

          setHrmPlacementCustomerSettings({
            ...emptyHrmPlacementCustomerSettings,
            ...(data?.settings || {}),
          });
        } catch {
          setHrmPlacementCustomerSettings(emptyHrmPlacementCustomerSettings);
        }
      }

      async function loadHrmPlacementCandidateSettings(companyCodeId = "") {
        try {
          const qs = companyCodeId
            ? `?company_code_id=${encodeURIComponent(companyCodeId)}`
            : "";

          const data = await tryFetchJson([
            `/api/company-section-settings/hrm_placement_candidate${qs}`,
          ]);

          setHrmPlacementCandidateSettings({
            ...emptyHrmPlacementCandidateSettings,
            ...(data?.settings || {}),
          });
        } catch {
          setHrmPlacementCandidateSettings(emptyHrmPlacementCandidateSettings);
        }
      }

      async function loadContacts(organisationId) {
        const id = safeTrim(organisationId);
        if (!id) {
          setContacts([]);
          return;
        }

        try {
          const data = await tryFetchJson([`/api/contacts?organisation_id=${encodeURIComponent(id)}`]);
          setContacts(Array.isArray(data) ? data : []);
        } catch {
          setContacts([]);
        }
      }

      async function loadList(keepSelection = true) {
        setLoading(true);
        setError(null);

        try {
          const params = new URLSearchParams();
          if (safeTrim(q)) params.set("q", safeTrim(q));
          const data = await tryFetchJson([`/api/placements?${params.toString()}`, `/api/plaatsingen?${params.toString()}`]);
          const rows = Array.isArray(data) ? data.map(normalizePlacement) : [];

          setItems(rows);

          if (keepSelection && selectedId) {
            const idx = rows.findIndex((x) => String(x.id) === String(selectedId));
            if (idx >= 0) {
              setListIndex(idx);
              return rows;
            }
          }

          setListIndex(rows.length ? 0 : -1);
          return rows;
        } catch (e) {
          setError(e?.message || String(e));
          setItems([]);
          setListIndex(-1);
          return [];
        } finally {
          setLoading(false);
        }
      }

      useEffect(() => {
        loadOrders();
        loadOrganisations();
        loadApplications();
        loadVacancies();
        loadPersonnel();
        loadInvoiceSettings();
        loadHrmPlacementCustomerSettings("");
        loadHrmPlacementCandidateSettings("");
        loadList(true);
        autoCreatePlacementFromUrl();
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);

      // Start rechtstreeks vanuit HRM Opdrachten.
      // Opdrachten stuurt ?new=1&order_id=<id> mee en bewaart daarnaast
      // staffiq_source_hrm_order_id als extra zekerheid.
      useEffect(() => {
        if (orderLaunchHandledRef.current) return;
        if (!orders.length || !organisations.length) return;

        const wantsNew = getParam("new") === "1";
        let orderId = safeTrim(getParam("order_id"));

        if (!orderId) {
          try {
            orderId = safeTrim(sessionStorage.getItem("staffiq_source_hrm_order_id") || "");
          } catch {}
        }

        if (!wantsNew || !orderId) {
          orderLaunchHandledRef.current = true;
          return;
        }

        const selectedOrder = (orders || []).find(
          (o) => String(o?.id ?? "") === String(orderId)
        );

        if (!selectedOrder) return;

        orderLaunchHandledRef.current = true;
        setLastApprovalInfo(null);
        setSavedConfirmations({ customer: false, candidate: false });
        setSelectedId(null);
        setListIndex(-1);
        setForm(emptyFormToday());
        setDocumentSetSummary({
          completed: 0,
          total: 0,
          complete: false,
          started: false,
        });
        setSaveError(null);
        setMode("form");
        setNoteEditor("");

        requestAnimationFrame(() => {
          applyOrderDefaults(orderId);

          try {
            rightScrollRef.current?.scrollTo?.({ top: 0, behavior: "auto" });
          } catch {}

          try {
            orderRef.current?.focus?.({ preventScroll: true });
          } catch {
            orderRef.current?.focus?.();
          }
        });

        try {
          sessionStorage.removeItem("staffiq_source_hrm_order_id");
        } catch {}

        try {
          window.history.replaceState({}, "", window.location.pathname);
        } catch {}
      }, [orders, organisations]);

      useEffect(() => {
        loadContacts(form.organisation_id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [form.organisation_id]);

      useEffect(() => {
        const companyCodeId =
          form.company_code_id ||
          selectedOrganisation?.company_code_id ||
          "";

        loadHrmPlacementCustomerSettings(companyCodeId);
        loadHrmPlacementCandidateSettings(companyCodeId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [form.company_code_id, form.organisation_id]);

      useEffect(() => {
        let reopenId = "";

        try {
          reopenId = sessionStorage.getItem("staffiq_reopen_placement_id") || "";
        } catch {}

        if (!reopenId || !items.length) return;

        const idx = items.findIndex((item) => String(item.id) === String(reopenId));
        if (idx < 0) return;

        try {
          sessionStorage.removeItem("staffiq_reopen_placement_id");
        } catch {}

        selectRow(items[idx], idx);

        let reopenDocumentSets = false;
        try {
          reopenDocumentSets = sessionStorage.getItem("staffiq_reopen_placement_documentsets") === "1";
          sessionStorage.removeItem("staffiq_reopen_placement_documentsets");
        } catch {}

        if (reopenDocumentSets) {
          setTimeout(() => {
            setDocumentSetsOpen(true);
            loadPlacementDocumentSets(reopenId);
          }, 120);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [items]);

      useEffect(() => {
        async function refreshSelectedPlacement() {
          const placementId = form.id || selectedId;
          if (!placementId) return;

          try {
            const latest = await tryFetchJson([
              `/api/placements/${encodeURIComponent(placementId)}`,
              `/api/plaatsingen/${encodeURIComponent(placementId)}`,
            ]);

            const normalized = normalizePlacement(latest);

            setForm((current) => {
              if (String(current.id || "") !== String(normalized.id || "")) {
                return current;
              }

              return normalized;
            });

            setItems((prev) =>
              (prev || []).map((item) =>
                String(item.id) === String(normalized.id)
                  ? normalized
                  : item
              )
            );
          } catch {
            // Terugkeren vanuit WhatsApp/e-mail mag nooit door een tijdelijke
            // netwerkfout worden geblokkeerd.
          }
        }

        function onFocus() {
          refreshSelectedPlacement();
        }

        function onVisibilityChange() {
          if (document.visibilityState === "visible") {
            refreshSelectedPlacement();
          }
        }

        window.addEventListener("focus", onFocus);
        document.addEventListener("visibilitychange", onVisibilityChange);

        return () => {
          window.removeEventListener("focus", onFocus);
          document.removeEventListener("visibilitychange", onVisibilityChange);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [form.id, selectedId]);


      function pickApplicationField(a, ...names) {
        for (const name of names) {
          const value = a?.[name];
          if (value !== undefined && value !== null && String(value).trim() !== "") {
            return value;
          }
        }
        return "";
      }

      function pickPersonnelField(p, ...names) {
        for (const name of names) {
          const value = p?.[name];
          if (value !== undefined && value !== null && String(value).trim() !== "") {
            return value;
          }
        }
        return "";
      }

      async function reloadListAndSelectPlacement(placementId, fallbackPlacement = null) {
        const data = await tryFetchJson(["/api/placements", "/api/plaatsingen"]);
        const rows = Array.isArray(data) ? data.map(normalizePlacement) : [];

        setQ("");
        setItems(rows);

        const idx = rows.findIndex((x) => String(x.id) === String(placementId));

        if (idx >= 0) {
          setSelectedId(rows[idx].id);
          setForm(normalizePlacement(rows[idx]));
          setListIndex(idx);
          setMode("form");
          return;
        }

        if (fallbackPlacement) {
          const normalized = normalizePlacement(fallbackPlacement);
          setSelectedId(normalized.id);
          setForm(normalized);
          setListIndex(-1);
          setMode("form");
        }
      }

      function readMatchingPlacementOverrides(applicationId, personnelId) {
        try {
          const raw = sessionStorage.getItem("staffiq_matching_placement_overrides");
          if (!raw) return {};

          const parsed = JSON.parse(raw);
          if (!parsed || typeof parsed !== "object") return {};

          if (
            String(parsed.application_id || "") !== String(applicationId || "") ||
            String(parsed.personnel_id || "") !== String(personnelId || "")
          ) {
            return {};
          }

          return parsed;
        } catch {
          return {};
        }
      }

      function clearMatchingPlacementOverrides() {
        try {
          sessionStorage.removeItem("staffiq_matching_placement_overrides");
        } catch {}
      }

      async function autoCreatePlacementFromUrl() {
        if (autoPlacementStartedRef.current) return;

        const urlApplicationId =
          safeTrim(getParam("application_id")) ||
          safeTrim(getParam("aanvraag_id")) ||
          safeTrim(getParam("applicationId")) ||
          safeTrim(getParam("aanvraagId"));

        const personnelId =
          safeTrim(getParam("personnel_id")) ||
          safeTrim(getParam("personeel_id")) ||
          safeTrim(getParam("personnelId")) ||
          safeTrim(getParam("personeelId"));

        const vacancyId =
          safeTrim(getParam("vacancy_id")) ||
          safeTrim(getParam("vacature_id")) ||
          safeTrim(getParam("vacancyId")) ||
          safeTrim(getParam("vacatureId"));

        if (!personnelId || (!urlApplicationId && !vacancyId)) return;

        autoPlacementStartedRef.current = true;
        setLoading(true);
        setSaveError(null);
        setFlash(vacancyId ? "Plaatsing wordt aangemaakt vanuit vacaturematching..." : "Plaatsing wordt aangemaakt vanuit matching...");

        let guardKey = "";

        try {
          let vacancy = null;

          if (vacancyId) {
            vacancy = await tryFetchJson([
              `/api/vacancies/${encodeURIComponent(vacancyId)}`,
              `/api/vacatures/${encodeURIComponent(vacancyId)}`,
            ]);
          }

          const applicationId = safeTrim(urlApplicationId || vacancy?.application_id || "");

          if (!applicationId) {
            throw new Error("Deze vacature is niet aan een aanvraag gekoppeld. Koppel eerst een aanvraag aan de vacature.");
          }

          guardKey = `staffiq_auto_placement_${applicationId}_${personnelId}_${vacancyId || "geen-vacature"}`;

          try {
            const currentGuard = sessionStorage.getItem(guardKey);
            if (currentGuard === "running") {
              autoPlacementStartedRef.current = false;
              setLoading(false);
              return;
            }
            sessionStorage.setItem(guardKey, "running");
          } catch {}

          const application = await tryFetchJson([
            `/api/applications/${encodeURIComponent(applicationId)}`,
            `/api/aanvragen/${encodeURIComponent(applicationId)}`,
          ]);

          const person = await tryFetchJson([
            `/api/personnel/${encodeURIComponent(personnelId)}`,
            `/api/personeel/${encodeURIComponent(personnelId)}`,
          ]);

          const matchingOverrides = readMatchingPlacementOverrides(
            applicationId,
            personnelId
          );

          const workflowOrganisationId =
            (vacancy && pickApplicationField(vacancy, "organisation_id", "organisatie_id")) ||
            pickApplicationField(application, "organisation_id", "organisatie_id");

          let workflowOrganisation = null;
          if (workflowOrganisationId) {
            try {
              workflowOrganisation = await tryFetchJson([
                `/api/organisations/${encodeURIComponent(workflowOrganisationId)}`,
              ]);
            } catch {}
          }


          const overrideJobTitle = safeTrim(matchingOverrides.job_title);
          const overrideHourlyWage = safeTrim(matchingOverrides.hourly_wage);
          const overridePurchaseRate = safeTrim(matchingOverrides.purchase_rate);
          const overrideSalesRate = safeTrim(matchingOverrides.sales_rate);
          const overrideEmploymentType = safeTrim(matchingOverrides.employment_type);
          const overrideRateLevel = safeTrim(matchingOverrides.rate_level);
          const overrideSupplierName = safeTrim(matchingOverrides.supplier_name);

          const isExternalEmployment =
            overrideEmploymentType === "ZZP" ||
            overrideEmploymentType === "Doorleen";

          function pickWorkflowField(...names) {
            const vacancyValue = vacancy ? pickApplicationField(vacancy, ...names) : "";
            if (vacancyValue !== "") return vacancyValue;
            return pickApplicationField(application, ...names);
          }

          const payload = {
            placement_date: new Date().toISOString().slice(0, 10),
            placement_number: "",
            status: "Concept",

            application_id: applicationId,
            vacancy_id: vacancyId || "",
            order_id: pickWorkflowField("order_id", "hrm_order_id") || "",
            organisation_id: pickWorkflowField("organisation_id", "organisatie_id"),
            contact_id: pickWorkflowField("contact_id", "contactpersoon_id"),
            personnel_id: personnelId,

            job_title:
              overrideJobTitle ||
              pickWorkflowField("job_title", "title", "functie", "vacaturetitel"),

            start_date: isoDate(pickWorkflowField("start_date", "startdatum")),
            end_date: isoDate(pickWorkflowField("end_date", "einddatum")),
            notice_period: safeTrim(pickWorkflowField("notice_period", "opzegtermijn")),
            hours_per_week: parseDecimal(pickWorkflowField("hours_per_week", "uren_per_week")),
            plan_morning: true,
            plan_afternoon: true,
            plan_weekends: vacancy?.plan_weekends === true,

            schedule_text: safeTrim(pickWorkflowField("schedule_text", "werktijden", "roostertekst")),
            location: safeTrim(pickWorkflowField("location", "locatie")) || organisationVisitAddressText(workflowOrganisation),
            location_contact: safeTrim(pickWorkflowField("location_contact", "contact_op_locatie")),
            registration_procedure: safeTrim(pickWorkflowField("registration_procedure", "aanmeldprocedure")),
            place: safeTrim(pickWorkflowField("place", "plaats")) || organisationVisitPlace(workflowOrganisation),
            region: safeTrim(pickWorkflowField("region", "regio")) || organisationVisitRegion(workflowOrganisation),

            cao: safeTrim(pickWorkflowField("cao")),
            wage_period: safeTrim(pickWorkflowField("wage_period", "loonperiode")) || "week",
            invoice_period: safeTrim(pickWorkflowField("invoice_period", "factuurperiode")) || "week",
            factor: parseDecimal(pickWorkflowField("factor")),
            employment_type:
              overrideEmploymentType ||
              pickPersonnelField(person, "employment_type") ||
              (person?.zzp === true ? "ZZP" : "Vast"),
            purchase_rate: parseDecimal(
              overridePurchaseRate ||
              pickPersonnelField(person, "zzp_purchase_rate", "purchase_rate", "inkooptarief")
            ),
            rate_level: overrideRateLevel || pickPersonnelField(person, "rate_level") || "",
            source_organisation_id:
              pickPersonnelField(person, "source_organisation_id") || null,
            supplier_name:
              overrideSupplierName ||
              pickPersonnelField(person, "zzp_company_name", "supplier_name") ||
              "",
            hourly_wage: parseDecimal(
              isExternalEmployment
                ? (
                    overridePurchaseRate ||
                    pickPersonnelField(person, "zzp_purchase_rate", "purchase_rate", "inkooptarief")
                  )
                : (
                    overrideHourlyWage ||
                    pickWorkflowField(
                      "rate_indication",
                      "salary_indication",
                      "salarisindicatie",
                      "hourly_wage",
                      "uurloon"
                    ) ||
                    pickPersonnelField(person, "hourly_wage", "uurloon")
                  )
            ),
            sales_rate: parseDecimal(
              overrideSalesRate ||
              pickWorkflowField("sales_rate", "verkooptarief") ||
              pickPersonnelField(
                person,
                isExternalEmployment ? "zzp_sales_rate" : "sales_rate",
                "verkooptarief"
              )
            ),
            travel_costs: parseDecimal(pickWorkflowField("travel_costs", "reiskosten")),
            travel_costs_unit: normalizeTravelCostsUnitForPlacement(pickWorkflowField("travel_costs_unit", "reiskosten_eenheid")),
            travel_hours_amount: parseDecimal(pickWorkflowField("travel_hours_amount", "reisuren")),
            travel_costs_unit: "km",
            own_transport:
              String(pickWorkflowField("own_transport", "eigen_vervoer") || "").trim().toLowerCase() === "ja"
                ? true
                : pickWorkflowField("company_transport", "vervoer_van_de_zaak") === true
                  ? false
                  : pickPersonnelField(person, "own_transport", "eigen_vervoer") === true,
            company_transport:
              pickWorkflowField("company_transport", "vervoer_van_de_zaak") === true
                ? true
                : String(pickWorkflowField("own_transport", "eigen_vervoer") || "").trim().toLowerCase() === "ja"
                  ? false
                  : pickPersonnelField(person, "company_transport", "vervoer_van_de_zaak") === true,
            charge_travel_costs: false,
            charge_travel_costs_unit: "km",
            charge_travel_costs_amount: null,
            allowances: safeTrim(pickWorkflowField("allowances", "toeslagen")),
            invoice_agreement: safeTrim(pickWorkflowField("invoice_agreement", "factuurafspraak")),

            candidate_status: "Concept",
            customer_status: "Concept",
            candidate_confirmed: false,
            customer_confirmed: false,

            internal_note: safeTrim(pickWorkflowField("internal_note", "opmerking_intern")),
            external_note: safeTrim(pickWorkflowField("external_note", "opmerking_extern")),
            remarks: "",
            active: true,
          };

          const saved = await tryFetchJson(["/api/placements", "/api/plaatsingen"], {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          });

          clearMatchingPlacementOverrides();

          await reloadListAndSelectPlacement(saved?.id, saved);

          try {
            const cleanUrl = `${window.location.pathname}`;
            window.history.replaceState({}, "", cleanUrl);
          } catch {}

          setFlash(vacancyId ? "Plaatsing aangemaakt vanuit vacaturematching ✅" : "Plaatsing aangemaakt vanuit matching ✅");
          setTimeout(() => setFlash(""), 2200);

          setTimeout(() => {
            try {
              rightScrollRef.current?.scrollTo?.({ top: 0, behavior: "auto" });
              dateRef.current?.focus?.({ preventScroll: true });
            } catch {}
          }, 120);
        } catch (e) {
          setSaveError(e?.message || String(e));
          setFlash("");
          autoPlacementStartedRef.current = false;

          if (guardKey) {
            try {
              sessionStorage.removeItem(guardKey);
            } catch {}
          }
        } finally {
          setLoading(false);
          if (guardKey) {
            setTimeout(() => {
              try {
                sessionStorage.removeItem(guardKey);
              } catch {}
            }, 2500);
          }
        }
      }

      function relationName(item) {
        return orgNameFromList(organisations, item?.organisation_id, item?.organisation_name || "");
      }

      function companyCodeName(item = form) {
        return orgCompanyCodeNameFromList(
          organisations,
          item?.organisation_id,
          pickCompanyCodeName(item)
        );
      }

      function personName(item) {
        const wanted = String(item?.personnel_id || "");
        const found = (personnel || []).find((p) => String(p.id) === wanted);
        return personnelName(found) || item?.personnel_name || "";
      }

      function vacancyLabel(v) {
        const nr = safeTrim(v?.vacancy_number || "");
        const rel = orgNameFromList(organisations, v?.organisation_id, v?.organisation_name || "");
        const title = safeTrim(v?.title || v?.job_title || "");
        return [nr, rel, title].filter(Boolean).join(" - ") || `Vacature #${v?.id}`;
      }

      function applicationLabel(a) {
        const nr = safeTrim(a?.application_number || "");
        const rel = orgNameFromList(organisations, a?.organisation_id, a?.organisation_name || "");
        const title = safeTrim(a?.title || a?.job_title || "");
        return [nr, rel, title].filter(Boolean).join(" - ") || `Aanvraag #${a?.id}`;
      }

      function rowText(item) {
        return [
          item?.placement_date,
          item?.placement_number,
          relationName(item),
          personName(item),
          item?.job_title,
          item?.status,
          orderReference(item),
          item?.start_date,
          item?.end_date,
          item?.notice_period,
          item?.hours_per_week,
          boolToJaNee(item?.plan_morning !== false),
          boolToJaNee(item?.plan_afternoon !== false),
          boolToJaNee(item?.plan_weekends === true),
          item?.location,
          item?.location_contact,
          item?.registration_procedure,
          item?.place,
          item?.region,
          item?.cao,
          companyCodeName(item),
          item?.wage_period,
          item?.invoice_period,
          item?.factor,
          item?.hourly_wage,
          item?.sales_rate,
          item?.travel_hours_amount,
          item?.candidate_status,
          item?.customer_status,
          item?.internal_note,
          item?.external_note,
          item?.remarks,
          boolToJaNee(parseActiveValue(item) !== false),
        ].join(" ");
      }

      function filterBySelect(value, filter) {
        if (!filter) return true;
        const v = safeTrim(value);
        if (filter === EMPTY_VAL) return !v;
        return norm(v) === norm(filter);
      }

      const filtered = useMemo(() => {
        const query = norm(q);

        return (items || []).filter((item) => {
          if (
            organisationFilterId &&
            String(item.organisation_id || "") !== String(organisationFilterId)
          ) {
            return false;
          }

          if (query && !norm(rowText(item)).includes(query)) return false;
          if (!filterBySelect(formatDateNL(item.placement_date), dateFilter)) return false;
          if (!filterBySelect(relationName(item), relationFilter)) return false;
          if (!filterBySelect(personName(item), personFilter)) return false;
          if (!filterBySelect(item.job_title, functionFilter)) return false;
          if (!filterBySelect(item.status, statusFilter)) return false;
          if (!filterBySelect(orderReference(item), orderFilter)) return false;
          if (!filterBySelect(item.cao, caoFilter)) return false;
          if (!filterBySelect(companyCodeName(item), companyCodeFilter)) return false;
          if (!filterBySelect(boolToJaNee(parseActiveValue(item) !== false), activeFilter)) return false;
          return true;
        });
      }, [items, q, dateFilter, relationFilter, personFilter, functionFilter, statusFilter, orderFilter, caoFilter, companyCodeFilter, activeFilter, organisations, personnel, organisationFilterId]);

      const sorted = useMemo(() => {
        const arr = [...filtered];
        const dir = sort.dir === "desc" ? -1 : 1;

        arr.sort((a, b) => {
          let av = "";
          let bv = "";

          if (sort.key === "date") {
            av = a.placement_date || "";
            bv = b.placement_date || "";
          } else if (sort.key === "relation") {
            av = relationName(a);
            bv = relationName(b);
          } else if (sort.key === "person") {
            av = personName(a);
            bv = personName(b);
          } else if (sort.key === "function") {
            av = a.job_title || "";
            bv = b.job_title || "";
          } else if (sort.key === "status") {
            av = a.status || "";
            bv = b.status || "";
          } else if (sort.key === "order") {
            av = orderReference(a);
            bv = orderReference(b);
          } else if (sort.key === "cao") {
            av = a.cao || "";
            bv = b.cao || "";
          } else if (sort.key === "companyCode") {
            av = companyCodeName(a);
            bv = companyCodeName(b);
          }

          return String(av).localeCompare(String(bv), "nl") * dir;
        });

        return arr;
      }, [filtered, sort, organisations, personnel]);

      const optionValues = useMemo(() => ({
        date: uniqSorted(items.map((x) => formatDateNL(x.placement_date))),
        relation: uniqSorted(items.map((x) => relationName(x))),
        person: uniqSorted(items.map((x) => personName(x))),
        function: uniqSorted(items.map((x) => x.job_title)),
        status: uniqSorted(items.map((x) => x.status)),
        order: uniqSorted(items.map((x) => orderReference(x))),
        cao: uniqSorted(items.map((x) => x.cao)),
        companyCode: uniqSorted(items.map((x) => companyCodeName(x))),
      }), [items, organisations, personnel]);

      const gridCount = Math.min(sorted.length, 9999);

      function setField(name, value) {
        setForm((f) => ({ ...f, [name]: value }));
      }

      function setMainStatus(value) {
        const s = safeTrim(value) || "Concept";

        setSavedConfirmations({ customer: false, candidate: false });

        setForm((f) => {
          const next = { ...f, status: s };

          if (norm(s) === "concept") {
            next.candidate_status = "Concept";
            next.customer_status = "Concept";
            next.candidate_confirmed = false;
            next.customer_confirmed = false;
          } else if (norm(s) === "voorgesteld") {
            next.candidate_status = "Voorgesteld";
            next.customer_status = "In behandeling";
            next.candidate_confirmed = false;
            next.customer_confirmed = false;
          } else if (norm(s) === "bevestigd") {
            next.candidate_status = "Akkoord";
            next.customer_status = "Akkoord";
            next.candidate_confirmed = true;
            next.customer_confirmed = true;
          } else if (norm(s) === "gestart") {
            next.candidate_status = "Gestart";
            next.customer_status = "Gestart";
            next.candidate_confirmed = true;
            next.customer_confirmed = true;
          } else if (norm(s) === "gestopt") {
            next.candidate_status = "Gestopt";
            next.customer_status = "Gestopt";
          } else if (norm(s) === "geannuleerd") {
            next.candidate_status = "Geannuleerd";
            next.customer_status = "Geannuleerd";
          }

          return next;
        });
      }

      function setCandidateConfirmed(checked) {
        setForm((f) => {
          const isConfirmedNow = norm(f.status || "") === "bevestigd";
          return {
            ...f,
            candidate_confirmed: checked === true,
            candidate_status: checked === true ? "Akkoord" : "Voorgesteld",
            status: checked === false && isConfirmedNow ? "Voorgesteld" : f.status,
          };
        });
      }

      function setCustomerConfirmed(checked) {
        setForm((f) => {
          const isConfirmedNow = norm(f.status || "") === "bevestigd";
          return {
            ...f,
            customer_confirmed: checked === true,
            customer_status: checked === true ? "Akkoord" : "In behandeling",
            status: checked === false && isConfirmedNow ? "Voorgesteld" : f.status,
          };
        });
      }

      function setDecimalField(name, value) {
        setForm((f) => ({ ...f, [name]: cleanDecimalInputValue(value) }));
      }

      function blurDecimalField(name, decimals = 2) {
        setForm((f) => ({ ...f, [name]: formatDecimalInputValue(f[name], decimals) }));
      }

      function newItem() {
        setLastApprovalInfo(null);
        setSavedConfirmations({ customer: false, candidate: false });
        setNoteEditor("");
        setSelectedId(null);
        setForm(emptyFormToday());
        setDocumentSetSummary({ completed: 0, total: 0, complete: false, started: false });
        setSaveError(null);
        setMode("form");
        setNoteEditor("");
        setTimeout(() => dateRef.current?.focus?.(), 80);
      }

      function selectRow(item, idx) {
        setLastApprovalInfo(null);
        setSavedConfirmations({ customer: false, candidate: false });
        setSelectedId(item.id);
        setForm(normalizePlacement(item));
        setListIndex(idx);
        setSaveError(null);
        setMode("form");
        setNoteEditor("");
        loadPlacementDocumentSetSummary(item.id);
        setTimeout(() => {
          try {
            const panel = rightScrollRef.current;
            if (!panel) return;

            // Altijd eerst de invoerkolom intern naar de eerste rubriek.
            panel.scrollTop = 0;

            if (window.innerWidth <= 768) {
              // Smartphone: zet de volledige invoerkolom bovenaan in het scherm.
              // Geen automatische focus, zodat het toetsenbord dicht blijft.
              panel.scrollIntoView?.({
                behavior: "smooth",
                block: "start",
                inline: "nearest",
              });

              if (
                document.activeElement &&
                typeof document.activeElement.blur === "function"
              ) {
                document.activeElement.blur();
              }

              return;
            }

            // Desktop: cursor op de eerste rubriek.
            dateRef.current?.focus?.();
          } catch {}
        }, 120);
      }

      function openCurrentRow() {
        const item = sorted[listIndex];
        if (item) selectRow(item, listIndex);
      }

      function moveCursor(dir) {
        if (!sorted.length) return;
        const next = Math.max(0, Math.min(sorted.length - 1, (listIndex < 0 ? 0 : listIndex) + dir));
        setListIndex(next);
        const item = sorted[next];
        if (item) {
          setLastApprovalInfo(null);
          setSelectedId(item.id);
          setForm(normalizePlacement(item));
        }
        setTimeout(() => rowRefs.current[next]?.scrollIntoView?.({ block: "nearest" }), 0);
      }

      async function saveItem() {
        if (isReadonlyRole) return;
        setSaveError(null);
        setLastApprovalInfo(null);

        if (form.plan_morning !== true && form.plan_afternoon !== true) {
          setSaveError("Kies minimaal Ochtend of Middag = Ja.");
          return;
        }

        if (form.own_transport === true && form.company_transport === true) {
          setSaveError("Kies bij Vervoer maximaal één optie: Eigen of Vd Zaak.");
          return;
        }

        if (form.charge_travel_costs === true && parseDecimal(form.charge_travel_costs_amount) <= 0) {
          setSaveError("Vul een bedrag in voor de reiskosten die aan de klant worden doorberekend.");
          return;
        }

        const payload = {
          ...form,
          order_id: form.order_id ? Number(form.order_id) : null,
          hours_per_week: parseDecimal(form.hours_per_week),
          factor: parseDecimal(form.factor),
          hourly_wage: parseDecimal(form.hourly_wage),
          employment_type: form.employment_type || "Vast",
          purchase_rate: parseDecimal(form.purchase_rate),
          rate_level: form.rate_level || "",
          source_organisation_id: form.source_organisation_id || null,
          supplier_name: form.supplier_name || "",
          sales_rate: parseDecimal(form.sales_rate),
          travel_costs: parseDecimal(form.travel_costs),
          travel_hours_amount: parseDecimal(form.travel_hours_amount),
          travel_costs_unit: form.travel_costs_unit === "day" ? "day" : "km",
          own_transport: form.own_transport === true,
          company_transport: form.company_transport === true,
          charge_travel_costs: form.charge_travel_costs === true,
          charge_travel_costs_unit: form.charge_travel_costs_unit === "day" ? "day" : "km",
          charge_travel_costs_amount:
            form.charge_travel_costs === true ? parseDecimal(form.charge_travel_costs_amount) : null,
          customer_confirmed: form.customer_confirmed === true,
          candidate_confirmed: form.candidate_confirmed === true,
          plan_morning: form.plan_morning === true,
          plan_afternoon: form.plan_afternoon === true,
          plan_weekends: form.plan_weekends === true,
          active: form.active !== false,
        };

        try {
          const saved = form.id
            ? await tryFetchJson([`/api/placements/${form.id}`, `/api/plaatsingen/${form.id}`], {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
              })
            : await tryFetchJson(["/api/placements", "/api/plaatsingen"], {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
              });

          const normalized = normalizePlacement(saved);

          // Lijst direct bijwerken met de opgeslagen plaatsing.
          setItems((prev) => {
            const idx = prev.findIndex((x) => String(x.id) === String(normalized.id));
            if (idx === -1) return [normalized, ...prev];
            const copy = prev.slice();
            copy[idx] = normalized;
            return copy;
          });

          // Na Opslaan dezelfde werkwijze als bij Aanvragen:
          // rechterkolom leegmaken, bovenaan positioneren en eerste gridregel selecteren.
          setSelectedId(null);
          setForm(emptyFormToday());
          setLastApprovalInfo(null);
          setSavedConfirmations({ customer: false, candidate: false });
          setNoteEditor("");
          setMode("search");
          setListIndex(0);

          // Lijst opnieuw laden zonder oude selectie vast te houden.
          await loadList(false);
          setListIndex(0);

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              try {
                // Rechterkolom helemaal naar boven.
                rightScrollRef.current?.scrollTo?.({
                  top: 0,
                  left: 0,
                  behavior: "auto",
                });
              } catch {}

              try {
                // Hele pagina / module bovenaan.
                pageTopRef.current?.scrollIntoView?.({
                  behavior: "auto",
                  block: "start",
                });
              } catch {}

              try {
                window.scrollTo({ top: 0, left: 0, behavior: "auto" });
                document.documentElement.scrollTop = 0;
                document.body.scrollTop = 0;
              } catch {}

              try {
                // Eerste gridregel zichtbaar.
                const firstRow = rowRefs.current?.[0];
                firstRow?.scrollIntoView?.({
                  behavior: "auto",
                  block: "nearest",
                  inline: "nearest",
                });
              } catch {}

              try {
                if (
                  document.activeElement &&
                  typeof document.activeElement.blur === "function"
                ) {
                  document.activeElement.blur();
                }
              } catch {}
            });
          });

          setFlash("Opgeslagen");
          setTimeout(() => setFlash(""), 1600);
        } catch (e) {
          setSaveError(e?.message || String(e));
        }
      }

      async function deleteItem() {
        setLastApprovalInfo(null);
        if (isReadonlyRole || !form.id) return;
        if (!window.confirm("Plaatsing verwijderen?")) return;

        try {
          await tryFetchJson([`/api/placements/${form.id}`, `/api/plaatsingen/${form.id}`], { method: "DELETE" });
          setSelectedId(null);
          setListIndex(-1);
          setForm(emptyFormToday());
          await loadList(false);
          setListIndex(-1);
          setMode("search");

          requestAnimationFrame(() => {
            try {
              rightScrollRef.current?.scrollTo?.({
                top: 0,
                left: 0,
                behavior: "auto",
              });
            } catch {}

            try {
              pageTopRef.current?.scrollIntoView?.({
                behavior: "auto",
                block: "start",
              });
            } catch {}

            try {
              window.scrollTo({ top: 0, left: 0, behavior: "auto" });
              document.documentElement.scrollTop = 0;
              document.body.scrollTop = 0;
            } catch {}

            if (window.innerWidth > 768) {
              setTimeout(() => {
                try {
                  searchRef.current?.focus?.({ preventScroll: true });
                } catch {
                  searchRef.current?.focus?.();
                }
              }, 0);
            }
          });
        } catch (e) {
          setSaveError(e?.message || String(e));
        }
      }

      async function vernieuwList() {
        setLastApprovalInfo(null);
        setOrganisationFilterId("");
        setSavedConfirmations({ customer: false, candidate: false });
        setSelectedId(null);
        setListIndex(-1);
        setForm({ ...emptyFormToday(), placement_date: "" });
        setDocumentSetSummary({ completed: 0, total: 0, complete: false, started: false });
        await loadList(false);
        setListIndex(-1);
        setMode("search");
        setTimeout(() => searchRef.current?.focus?.(), 80);
      }

      function applyApplication(applicationId) {
        const a = (applications || []).find(
          (item) => String(item.id) === String(applicationId)
        );

        if (!a) {
          setField("application_id", applicationId);
          return;
        }

        const aOrg = (organisations || []).find((o) => String(orgIdOf(o)) === String(a.organisation_id || ""));

        setForm((f) => ({
          ...f,
          application_id: a.id || "",
          order_id: a.order_id || f.order_id || "",
          organisation_id: a.organisation_id || f.organisation_id || "",
          contact_id: a.contact_id || f.contact_id || "",
          company_code_id: a.company_code_id || f.company_code_id || "",
          company_code: a.company_code || f.company_code || "",
          company_code_name: a.company_code_name || f.company_code_name || "",
          job_title: a.job_title || a.title || f.job_title || "",
          start_date: isoDate(a.start_date) || f.start_date || "",
          end_date: isoDate(a.end_date) || f.end_date || "",
          notice_period: a.notice_period || f.notice_period || "",
          hours_per_week:
            decimalInput(a.hours_per_week, 2) || f.hours_per_week || "",
          plan_morning: f.plan_morning !== false,
          plan_afternoon: f.plan_afternoon !== false,
          plan_weekends: f.plan_weekends === true,
          schedule_text: a.schedule_text || f.schedule_text || "",
          location: a.location || f.location || organisationVisitAddressText(aOrg),
          location_contact: a.location_contact || f.location_contact || "",
          registration_procedure: a.registration_procedure || f.registration_procedure || "",
          place: a.place || f.place || organisationVisitPlace(aOrg),
          region: a.region || f.region || organisationVisitRegion(aOrg),
          cao: a.cao || f.cao || "",
          wage_period: a.wage_period || f.wage_period || "week",
          invoice_period: a.invoice_period || f.invoice_period || "week",
          factor: decimalInput(a.factor, 2) || f.factor || "",
          hourly_wage:
            decimalInput(
              a.rate_indication ??
              a.salary_indication ??
              a.salarisindicatie ??
              a.hourly_wage,
              2
            ) ||
            f.hourly_wage ||
            "",
          sales_rate: decimalInput(a.sales_rate, 2) || f.sales_rate || "",
          travel_costs:
            decimalInput(a.travel_costs, 2) || f.travel_costs || "",
          travel_hours_amount:
            decimalInput(a.travel_hours_amount, 2) || f.travel_hours_amount || "",
          travel_costs_unit: normalizeTravelCostsUnitForPlacement(a.travel_costs_unit || f.travel_costs_unit),
          own_transport:
            a.company_transport === true
              ? false
              : String(a.own_transport || "").trim().toLowerCase() === "ja"
                ? true
                : f.own_transport === true,
          company_transport:
            a.company_transport === true
              ? true
              : String(a.own_transport || "").trim().toLowerCase() === "ja"
                ? false
                : f.company_transport === true,
          allowances: a.allowances || f.allowances || "",
          invoice_agreement:
            a.invoice_agreement || f.invoice_agreement || "",
          internal_note: a.internal_note || f.internal_note || "",
          external_note: a.external_note || f.external_note || "",
          remarks: a.remarks || f.remarks || "",
        }));
      }

      function applyPersonnel(personnelId) {
        const p = (personnel || []).find((x) => String(x.id) === String(personnelId));

        if (!p) {
          setField("personnel_id", personnelId);
          return;
        }

        const a = (applications || []).find(
          (x) => String(x.id) === String(form.application_id || "")
        );

        const applicationCompanyTransport = a?.company_transport === true;
        const applicationOwnTransport =
          String(a?.own_transport || "").trim().toLowerCase() === "ja";
        const applicationHasTransportChoice =
          applicationCompanyTransport || applicationOwnTransport;

        setForm((f) => ({
          ...f,
          personnel_id: p.id || "",
          employment_type: p.employment_type || (p.zzp === true ? "ZZP" : "Vast"),
          hourly_wage: f.hourly_wage || decimalInput(p.hourly_wage, 2) || "",
          purchase_rate: f.purchase_rate || decimalInput(p.zzp_purchase_rate ?? p.purchase_rate, 2) || "",
          rate_level: f.rate_level || p.rate_level || "",
          source_organisation_id: p.source_organisation_id || "",
          supplier_name: p.zzp_company_name || p.supplier_name || "",
          sales_rate:
            f.sales_rate ||
            decimalInput(
              ["ZZP", "Doorleen"].includes(p.employment_type)
                ? (p.zzp_sales_rate ?? p.sales_rate)
                : p.sales_rate,
              2
            ) ||
            "",
          own_transport: applicationHasTransportChoice
            ? applicationOwnTransport
            : p.own_transport === true,
          company_transport: applicationHasTransportChoice
            ? applicationCompanyTransport
            : p.company_transport === true,
        }));
      }

      function applyVacancy(vacancyId) {
        const v = (vacancies || []).find((x) => String(x.id) === String(vacancyId));
        if (!v) return;

        const vOrg = (organisations || []).find((o) => String(orgIdOf(o)) === String(v.organisation_id || ""));

        setForm((f) => ({
          ...f,
          vacancy_id: v.id || "",
          application_id: v.application_id || f.application_id || "",
          order_id: v.order_id || f.order_id || "",
          organisation_id: v.organisation_id || f.organisation_id || "",
          contact_id: v.contact_id || f.contact_id || "",
          company_code_id: v.company_code_id || f.company_code_id || "",
          company_code: v.company_code || f.company_code || "",
          company_code_name: v.company_code_name || f.company_code_name || "",
          job_title: v.job_title || f.job_title || "",
          start_date: isoDate(v.start_date) || f.start_date || "",
          end_date: isoDate(v.end_date) || f.end_date || "",
          notice_period: v.notice_period || f.notice_period || "",
          hours_per_week: decimalInput(v.hours_per_week, 2) || f.hours_per_week || "",
          plan_morning: f.plan_morning !== false,
          plan_afternoon: f.plan_afternoon !== false,
          plan_weekends: f.plan_weekends === true,
          schedule_text: v.schedule_text || f.schedule_text || "",
          location: v.location || f.location || organisationVisitAddressText(vOrg),
          location_contact: v.location_contact || f.location_contact || "",
          registration_procedure: v.registration_procedure || f.registration_procedure || "",
          place: v.place || f.place || organisationVisitPlace(vOrg),
          region: v.region || f.region || organisationVisitRegion(vOrg),
          cao: v.cao || f.cao || "",
          wage_period: v.wage_period || f.wage_period || "week",
          invoice_period: v.invoice_period || f.invoice_period || "week",
          factor: decimalInput(v.factor, 2) || f.factor || "",
          sales_rate: decimalInput(v.sales_rate, 2) || f.sales_rate || "",
          travel_costs: decimalInput(v.travel_costs, 2) || f.travel_costs || "",
          travel_costs_unit: normalizeTravelCostsUnitForPlacement(v.travel_costs_unit || f.travel_costs_unit),
          travel_hours_amount: decimalInput(v.travel_hours_amount, 2) || f.travel_hours_amount || "",
          allowances: v.allowances || f.allowances || "",
          invoice_agreement: v.invoice_agreement || f.invoice_agreement || "",
          internal_note: v.internal_note || f.internal_note || "",
          external_note: v.external_note || f.external_note || "",
          remarks: v.remarks || f.remarks || "",
        }));
      }


      const selectedOrganisation = useMemo(() => {
        const oid = String(form.organisation_id || "");
        if (!oid) return null;
        return (organisations || []).find((o) => String(orgIdOf(o)) === oid) || null;
      }, [form.organisation_id, organisations]);

      function relationGAccountPercentage(org) {
        const raw =
          org?.g_account_percentage ??
          org?.grekening_percentage ??
          org?.g_rekening_percentage ??
          org?.g_percentage ??
          org?.g_account_percent ??
          "";

        const n = parseDecimal(raw);
        return Number.isFinite(n) && n > 0 ? Math.min(100, n) : 0;
      }

      const selectedContact = useMemo(() => {
        const cid = String(form.contact_id || "");
        if (!cid) return null;
        return (contacts || []).find((c) => String(contactIdOf(c)) === cid) || null;
      }, [form.contact_id, contacts]);

      const selectedPersonnel = useMemo(() => {
        const pid = String(form.personnel_id || "");
        if (!pid) return null;
        return (personnel || []).find((p) => String(p.id || "") === pid) || null;
      }, [form.personnel_id, personnel]);

      function htmlEscape(v) {
        return String(v ?? "")
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;")
          .replace(/'/g, "&#039;");
      }

      function htmlLines(v) {
        const s = safeTrim(v);
        if (!s) return "-";
        return htmlEscape(s).replace(/\n/g, "<br/>");
      }

      function currentCustomerEmail() {
        // Klantbevestiging moet naar het bedrijf/de relatie worden gestuurd,
        // niet naar de contactpersoon.
        return safeTrim(selectedOrganisation?.email || "");
      }

      function currentCandidateEmail() {
        return safeTrim(selectedPersonnel?.email || "");
      }

      function boolFromAny(value) {
        return value === true || value === 1 || value === "1" || value === "true" || value === "ja" || value === "j";
      }

      function currentCustomerMobile() {
        return safeTrim(selectedOrganisation?.mobile || "");
      }

      function currentCandidateMobile() {
        return safeTrim(selectedPersonnel?.mobile || "");
      }

      function approvalChannelLabel(channel) {
        if (channel === "both") return "WhatsApp + E-mail";
        if (channel === "whatsapp") return "WhatsApp";
        if (channel === "email") return "E-mail";
        if (channel === "manual") return "Wel akkoord, geen bericht";
        return "";
      }

      function approvalKindLabel(kind) {
        return kind === "candidate" ? "kandidaat" : "klant";
      }

      function getPlacementApprovalPreference(kind) {
        if (kind === "candidate") {
          const mobile = currentCandidateMobile();
          const email = currentCandidateEmail();

          return {
            mobile,
            email,
            whatsappAllowed: boolFromAny(selectedPersonnel?.correspondence_whatsapp) && !!mobile,
            emailAllowed: boolFromAny(selectedPersonnel?.correspondence_email) && !!email,
          };
        }

        const mobile = currentCustomerMobile();
        const email = currentCustomerEmail();

        return {
          mobile,
          email,
          whatsappAllowed: boolFromAny(selectedOrganisation?.correspondence_whatsapp) && !!mobile,
          emailAllowed: boolFromAny(selectedOrganisation?.correspondence_email) && !!email,
        };
      }

      function chooseApprovalChannelForPlacement(kind, pref) {
        const label = approvalKindLabel(kind);

        return new Promise((resolve) => {
          const overlay = document.createElement("div");
          overlay.style.position = "fixed";
          overlay.style.left = "0";
          overlay.style.top = "0";
          overlay.style.right = "0";
          overlay.style.bottom = "0";
          overlay.style.background = "rgba(0,0,0,0.35)";
          overlay.style.zIndex = "999999";
          overlay.style.display = "flex";
          overlay.style.alignItems = "center";
          overlay.style.justifyContent = "center";
          overlay.style.padding = "18px";
          overlay.style.boxSizing = "border-box";

          const box = document.createElement("div");
          box.style.width = "min(560px, 100%)";
          box.style.background = "#fff";
          box.style.borderRadius = "12px";
          box.style.boxShadow = "0 18px 50px rgba(0,0,0,0.35)";
          box.style.padding = "18px";
          box.style.boxSizing = "border-box";
          box.style.fontFamily = "Arial, Helvetica, sans-serif";
          box.style.color = "#111";

          const title = document.createElement("div");
          title.style.fontWeight = "700";
          title.style.fontSize = "18px";
          title.style.marginBottom = "8px";
          title.textContent = `Plaatsingsbevestiging ${label} ter akkoord aanbieden`;

          const help = document.createElement("div");
          help.style.fontSize = "14px";
          help.style.color = "#555";
          help.style.lineHeight = "1.45";
          help.style.marginBottom = "14px";
          help.textContent = "Kies de gewenste actie.";

          const grid = document.createElement("div");
          grid.style.display = "grid";
          grid.style.gridTemplateColumns = "1fr";
          grid.style.gap = "8px";
          grid.style.marginBottom = "14px";

          let done = false;

          function cleanup(value) {
            if (done) return;
            done = true;

            try {
              document.body.removeChild(overlay);
            } catch {}

            resolve(value);
          }

          function addChoice(value, text, enabled = true) {
            const btn = document.createElement("button");
            btn.type = "button";
            btn.textContent = text;
            btn.disabled = !enabled;
            btn.style.padding = "11px 12px";
            btn.style.border = "1px solid #d0d0d0";
            btn.style.borderRadius = "8px";
            btn.style.background = enabled ? "#fff" : "#f2f2f2";
            btn.style.color = enabled ? "#111" : "#888";
            btn.style.fontSize = "15px";
            btn.style.fontWeight = "600";
            btn.style.textAlign = "left";
            btn.style.cursor = enabled ? "pointer" : "not-allowed";

            if (enabled) {
              btn.onclick = () => cleanup(value);
            }

            grid.appendChild(btn);
          }

          addChoice("whatsapp", "1 = WhatsApp", pref.whatsappAllowed);
          addChoice("email", "2 = E-mail", pref.emailAllowed);
          addChoice("both", "3 = WhatsApp + E-mail", pref.whatsappAllowed && pref.emailAllowed);
          addChoice("manual", "4 = Wel akkoord, geen WhatsApp of E-mail", true);

          const bottom = document.createElement("div");
          bottom.style.display = "flex";
          bottom.style.justifyContent = "flex-end";
          bottom.style.gap = "10px";

          const cancelButton = document.createElement("button");
          cancelButton.type = "button";
          cancelButton.textContent = "Annuleren";
          cancelButton.style.padding = "10px 18px";
          cancelButton.style.border = "1px solid #d0d0d0";
          cancelButton.style.borderRadius = "8px";
          cancelButton.style.background = "#fff";
          cancelButton.style.color = "#111";
          cancelButton.style.fontSize = "15px";
          cancelButton.style.cursor = "pointer";
          cancelButton.onclick = () => cleanup("");

          bottom.appendChild(cancelButton);

          box.appendChild(title);
          box.appendChild(help);
          box.appendChild(grid);
          box.appendChild(bottom);

          overlay.appendChild(box);
          document.body.appendChild(overlay);

          overlay.onclick = (ev) => {
            if (ev.target === overlay) cleanup("");
          };

          window.addEventListener("keydown", function onKeyDown(ev) {
            if (done) {
              window.removeEventListener("keydown", onKeyDown);
              return;
            }

            if (ev.key === "Escape") {
              ev.preventDefault();
              window.removeEventListener("keydown", onKeyDown);
              cleanup("");
              return;
            }

            if (ev.key === "1" && pref.whatsappAllowed) {
              ev.preventDefault();
              window.removeEventListener("keydown", onKeyDown);
              cleanup("whatsapp");
              return;
            }

            if (ev.key === "2" && pref.emailAllowed) {
              ev.preventDefault();
              window.removeEventListener("keydown", onKeyDown);
              cleanup("email");
              return;
            }

            if (ev.key === "3" && pref.whatsappAllowed && pref.emailAllowed) {
              ev.preventDefault();
              window.removeEventListener("keydown", onKeyDown);
              cleanup("both");
              return;
            }

            if (ev.key === "4") {
              ev.preventDefault();
              window.removeEventListener("keydown", onKeyDown);
              cleanup("manual");
            }
          });
        });
      }

      function isMobileDeviceForWhatsapp() {
        try {
          return /Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent || "");
        } catch {
          return false;
        }
      }

      function whatsappAppUrlFromWebUrl(webUrl) {
        const raw = safeTrim(webUrl);
        if (!raw) return "";

        try {
          const parsed = new URL(raw);
          const host = String(parsed.hostname || "").toLowerCase();

          if (!host.includes("wa.me") && !host.includes("whatsapp.com")) {
            return raw;
          }

          let phone = "";

          if (host.includes("wa.me")) {
            phone = parsed.pathname.replace(/^\/+/, "").split("/")[0] || "";
          } else {
            phone = parsed.searchParams.get("phone") || "";
          }

          const text = parsed.searchParams.get("text") || "";
          const params = new URLSearchParams();

          if (phone) params.set("phone", phone.replace(/[^\d]/g, ""));
          if (text) params.set("text", text);

          const query = params.toString();
          return `whatsapp://send${query ? `?${query}` : ""}`;
        } catch {
          return raw;
        }
      }

      function bestWhatsappOpenUrl(webUrl) {
        const raw = safeTrim(webUrl);
        if (!raw) return "";
        return isMobileDeviceForWhatsapp() ? whatsappAppUrlFromWebUrl(raw) : raw;
      }

      function openWhatsAppSmart(webUrl) {
        const raw = safeTrim(webUrl);
        if (!raw) return;

        const target = bestWhatsappOpenUrl(raw);

        if (isMobileDeviceForWhatsapp()) {
          try {
            window.location.href = target;
            return;
          } catch {}
        }

        window.open(target, "_blank", "noopener,noreferrer");
      }

      function escapeAttr(value) {
        return String(value || "")
          .replace(/&/g, "&amp;")
          .replace(/"/g, "&quot;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;");
      }

      function writeWhatsappReadyPage(whatsappWindow, webUrl) {
        if (!whatsappWindow || whatsappWindow.closed) return false;

        const raw = safeTrim(webUrl);
        if (!raw) return false;

        const appUrl = bestWhatsappOpenUrl(raw);
        const fallbackUrl = raw;
        const appUrlJs = JSON.stringify(appUrl);
        const fallbackUrlJs = JSON.stringify(fallbackUrl);

        try {
          whatsappWindow.document.open();
          whatsappWindow.document.write(`
            <html>
              <head>
                <title>WhatsApp openen</title>
                <meta name="viewport" content="width=device-width, initial-scale=1" />
              </head>
              <body style="font-family: Arial, sans-serif; padding: 24px; line-height: 1.45; color: #111;">
                <h2>WhatsApp staat klaar</h2>
                <p>
                  Tik op de groene knop hieronder om het bericht in WhatsApp te openen.
                  Daarna moet je het bericht zelf nog verzenden.
                </p>

                <p style="margin: 24px 0 12px 0;">
                  <button
                    type="button"
                    onclick="openWhatsappAndReturn()"
                    style="display:inline-block;background:#25D366;color:#111;text-decoration:none;padding:14px 18px;border:0;border-radius:8px;font-weight:700;font-size:16px;cursor:pointer;"
                  >
                    Open WhatsApp
                  </button>
                </p>

                <p style="margin: 8px 0 24px 0; color:#555;">
                  Na het versturen van de WhatsApp kunt u met onderstaande knop terug naar StaffIQ.
                </p>

                <p style="margin: 0 0 24px 0;">
                  <button
                    type="button"
                    onclick="backToStaffiq()"
                    style="display:inline-block;background:#1f4e79;color:#fff;text-decoration:none;padding:12px 16px;border:0;border-radius:8px;font-weight:700;font-size:15px;cursor:pointer;"
                  >
                    Terug naar Plaatsingen
                  </button>
                </p>

                <p style="font-size:13px;color:#555;">
                  Werkt de groene knop niet? Probeer dan deze koppeling:<br />
                  <a href="${escapeAttr(fallbackUrl)}" style="word-break:break-all;">Open via WhatsApp-web</a>
                </p>

                <script>
                  const appUrl = ${appUrlJs};
                  const fallbackUrl = ${fallbackUrlJs};

                  function backToStaffiq() {
                    try { window.close(); } catch (e) {}
                    setTimeout(function() {
                      try { window.location.href = "/plaatsingen"; } catch (e) {}
                    }, 150);
                  }

                  function openWhatsappAndReturn() {
                    try { window.location.href = appUrl || fallbackUrl; } catch (e) {}
                    setTimeout(function() {
                      try { window.close(); } catch (e) {}
                      try { window.location.href = "/plaatsingen"; } catch (e) {}
                    }, 1200);
                  }
                </script>
              </body>
            </html>
          `);
          whatsappWindow.document.close();

          if (isMobileDeviceForWhatsapp()) {
            setTimeout(() => {
              try {
                whatsappWindow.location.href = appUrl;
              } catch {}
            }, 250);
          } else {
            try {
              whatsappWindow.location.href = fallbackUrl;
            } catch {}
          }

          return true;
        } catch {
          return false;
        }
      }

      async function sendApprovalEmail(approvalId) {
        if (!approvalId) throw new Error("Akkoordverzoek-id ontbreekt.");

        return await tryFetchJson(
          [`/api/document-approvals/${encodeURIComponent(approvalId)}/send-email`],
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({}),
          }
        );
      }

      async function createPlacementApprovalRequest(kind, channel) {
        const isCandidate = kind === "candidate";
        const documentType = isCandidate ? "placement_candidate" : "placement_customer";
        const label = isCandidate ? "plaatsingsbevestiging kandidaat" : "plaatsingsbevestiging klant";
        const receiver = isCandidate ? (personnelName(selectedPersonnel) || personName(form)) : (pickOrgName(selectedOrganisation) || relationName(form));

        const approvalText = isCandidate
          ? replacePlacementVariables(
              hrmPlacementCandidateSettings.approval_text ||
                emptyHrmPlacementCandidateSettings.approval_text,
              {
                document_nummer: form.placement_number || form.id || "",
                relatie: receiver || "de relatie",
                contactpersoon: displayPersonName(selectedPersonnel, personName(form)),
                kandidaat: displayPersonName(selectedPersonnel, personName(form)),
                functie: form.job_title || "",
                startdatum: formatDateNL(form.start_date),
                einddatum: formatDateNL(form.end_date),
                bedrijfscode: companyCodeName(form),
              }
            )
          : replacePlacementVariables(
              hrmPlacementCustomerSettings.approval_text ||
                emptyHrmPlacementCustomerSettings.approval_text,
              {
                document_nummer: form.placement_number || form.id || "",
                relatie: receiver || "de relatie",
                contactpersoon: displayContactName(selectedContact, pickContactName(selectedContact)),
                kandidaat: displayPersonName(selectedPersonnel, personName(form)),
                functie: form.job_title || "",
                startdatum: formatDateNL(form.start_date),
                einddatum: formatDateNL(form.end_date),
                bedrijfscode: companyCodeName(form),
              }
            );

        return await tryFetchJson(["/api/document-approvals"], {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            document_type: documentType,
            document_id: Number(form.id),
            channel,
            approval_text: approvalText,
            remarks: "",
          }),
        });
      }

      async function sendPlacementForApproval(kind) {
        if (isReadonlyRole) return;

        setSaveError(null);
        setLastApprovalInfo(null);

        if (!form.id) {
          setSaveError("Sla de plaatsing eerst op voordat je een akkoordverzoek maakt.");
          return;
        }

        const pref = getPlacementApprovalPreference(kind);
        const label = approvalKindLabel(kind);

        const chosenChannel = await chooseApprovalChannelForPlacement(kind, pref);
        if (!chosenChannel) return;

        if (chosenChannel === "manual") {
          const otherAlreadyOk = kind === "candidate"
            ? form.customer_confirmed === true
            : form.candidate_confirmed === true;

          await savePlacementProcessFields(
            kind === "candidate"
              ? {
                  status: otherAlreadyOk ? "Bevestigd" : "Voorgesteld",
                  candidate_confirmed: true,
                  candidate_status: "Akkoord",
                  customer_status: otherAlreadyOk ? "Akkoord" : (form.customer_status || "In behandeling"),
                }
              : {
                  status: otherAlreadyOk ? "Bevestigd" : "Voorgesteld",
                  customer_confirmed: true,
                  customer_status: "Akkoord",
                  candidate_status: otherAlreadyOk ? "Akkoord" : (form.candidate_status || "Voorgesteld"),
                },
            kind === "candidate"
              ? (otherAlreadyOk ? "Kandidaat akkoord. Plaatsing is nu bevestigd" : "Kandidaat akkoord")
              : (otherAlreadyOk ? "Klant akkoord. Plaatsing is nu bevestigd" : "Klant akkoord"),
            kind === "candidate"
              ? "Kandidaat akkoord zetten zonder WhatsApp of E-mail?"
              : "Klant akkoord zetten zonder WhatsApp of E-mail?"
          );
          return;
        }

        if ((chosenChannel === "whatsapp" && !pref.whatsappAllowed) ||
            (chosenChannel === "email" && !pref.emailAllowed) ||
            (chosenChannel === "both" && (!pref.whatsappAllowed || !pref.emailAllowed))) {
          setSaveError("Deze verzendwijze is niet beschikbaar. Controleer mobiel/e-mail en de correspondentie-vinkjes.");
          return;
        }

        if (!(pref.whatsappAllowed && pref.emailAllowed)) {
          const ok = window.confirm(
            `Plaatsingsbevestiging ${label} ter akkoord aanbieden via ${approvalChannelLabel(chosenChannel)}?`
          );

          if (!ok) return;
        }

        let whatsappWindow = null;
        const wantsWhatsapp = chosenChannel === "whatsapp" || chosenChannel === "both";

        if (wantsWhatsapp) {
          try {
            whatsappWindow = window.open("", "_blank");

            if (whatsappWindow) {
              try { whatsappWindow.opener = null; } catch {}
              whatsappWindow.document.open();
              whatsappWindow.document.write(`
                <html>
                  <head><title>WhatsApp openen</title></head>
                  <body style="font-family: Arial, sans-serif; padding: 24px;">
                    <h2>WhatsApp wordt voorbereid...</h2>
                    <p>Dit venster wordt zo doorgestuurd naar WhatsApp.</p>
                  </body>
                </html>
              `);
              whatsappWindow.document.close();
            }
          } catch {
            whatsappWindow = null;
          }
        }

        try {
          setSendingApproval(true);

          await savePlacementConfirmation(kind, { silent: true });

          const requestChannel = chosenChannel === "email" ? "email" : "whatsapp";
          const created = await createPlacementApprovalRequest(kind, requestChannel);
          const approval = created?.approval || {};
          const approvalId = approval?.id || created?.id;
          const approvalUrl = created?.approval_url || approval?.approval_url || "";
          const whatsappUrl = created?.whatsapp_url || approval?.whatsapp_url || "";

          let popupBlocked = false;
          let emailResult = null;

          if (wantsWhatsapp) {
            if (whatsappUrl) {
              if (whatsappWindow && !whatsappWindow.closed) {
                const readyPageWritten = writeWhatsappReadyPage(whatsappWindow, whatsappUrl);
                if (!readyPageWritten) {
                  whatsappWindow.location.href = bestWhatsappOpenUrl(whatsappUrl);
                }
              } else {
                popupBlocked = true;
              }
            } else if (whatsappWindow && !whatsappWindow.closed) {
              try {
                whatsappWindow.close();
              } catch {}
            }
          }

          setLastApprovalInfo({
            approval_id: approvalId,
            approval_url: approvalUrl,
            whatsapp_url: whatsappUrl,
            channel: chosenChannel,
            kind,
            popup_blocked: popupBlocked,
            sent_by_name: approval?.sent_by_name || "",
            sent_by_email: approval?.sent_by_email || "",
            sent_to_name: approval?.sent_to_name || "",
            sent_to: approval?.sent_to || approval?.sent_to_email || approval?.sent_to_mobile || "",
          });

          if (chosenChannel === "email" || chosenChannel === "both") {
            emailResult = await sendApprovalEmail(approvalId);

            const accepted = Array.isArray(emailResult?.accepted)
              ? emailResult.accepted.join(", ")
              : "";

            const rejected = Array.isArray(emailResult?.rejected)
              ? emailResult.rejected.join(", ")
              : "";

            setLastApprovalInfo((prev) => ({
              ...(prev || {}),
              approval_id: approvalId,
              approval_url: approvalUrl,
              whatsapp_url: whatsappUrl,
              channel: chosenChannel,
              kind,
              popup_blocked: popupBlocked,
              sent_by_name: approval?.sent_by_name || "",
              sent_by_email: approval?.sent_by_email || "",
              sent_to_name: approval?.sent_to_name || "",
              sent_to: approval?.sent_to || approval?.sent_to_email || approval?.sent_to_mobile || "",
              email_to: emailResult?.to || "",
              email_message: emailResult?.message || "",
              email_accepted: accepted,
              email_rejected: rejected,
            }));

            alert(
              `${emailResult?.message || "Akkoordverzoek per e-mail verstuurd."}` +
                `${accepted ? `\nGeaccepteerd door mailserver: ${accepted}` : ""}` +
                `${rejected ? `\nNiet geaccepteerd: ${rejected}` : ""}`
            );
          }

          if (chosenChannel === "both") {
            setFlash(popupBlocked
              ? "Akkoordlink gemaakt. E-mail verstuurd. WhatsApp-popup is geblokkeerd; gebruik de WhatsApp-link hieronder."
              : (isMobileDeviceForWhatsapp() ? "Akkoordlink gemaakt. E-mail verstuurd. WhatsApp staat klaar in het geopende venster ✅" : "Akkoordlink gemaakt. WhatsApp geopend en e-mail verstuurd ✅")
            );
          } else if (chosenChannel === "whatsapp") {
            setFlash(popupBlocked
              ? "Akkoordlink gemaakt. WhatsApp-popup is geblokkeerd; gebruik de WhatsApp-link hieronder."
              : (isMobileDeviceForWhatsapp() ? "Akkoordlink gemaakt. WhatsApp staat klaar in het geopende venster ✅" : "Akkoordlink gemaakt en WhatsApp geopend ✅")
            );
          } else {
            setFlash("Akkoordverzoek per e-mail verstuurd ✅");
          }

          setTimeout(() => setFlash(""), 2200);
        } catch (e) {
          try {
            if (whatsappWindow && !whatsappWindow.closed) whatsappWindow.close();
          } catch {}
          setSaveError(e?.message || String(e));
        } finally {
          setSendingApproval(false);
        }
      }

      function buildPlacementPrintHtml(kind = "customer") {
        const isCandidate = kind === "candidate";
        const relation = pickOrgName(selectedOrganisation) || relationName(form);
        const contact = displayContactName(selectedContact, pickContactName(selectedContact));
        const candidate = displayPersonName(selectedPersonnel, personName(form));
        const placementNo = safeTrim(form.placement_number || "") || String(form.id || "");
        const customerSettings = {
          ...emptyHrmPlacementCustomerSettings,
          ...(hrmPlacementCustomerSettings || {}),
        };
        const candidateSettings = {
          ...emptyHrmPlacementCandidateSettings,
          ...(hrmPlacementCandidateSettings || {}),
        };
        const activeSettings = isCandidate ? candidateSettings : customerSettings;
        const activeDefaults = isCandidate
          ? emptyHrmPlacementCandidateSettings
          : emptyHrmPlacementCustomerSettings;
        const title =
          safeTrim(activeSettings.document_title) ||
          activeDefaults.document_title;
        const today = formatDateNL(new Date().toISOString().slice(0, 10));

        // Plaatsingsbevestigingen hebben eigen HRM-documentinstellingen.
        // Niet terugvallen op oude offerte/factuurinstellingen: een bewust leeg
        // veld (zoals Adresregel 2) moet ook werkelijk leeg blijven.
        const companyName = safeTrim(activeSettings.company_name || "StaffIQ");
        const companyAddress1 = safeTrim(activeSettings.company_address_1 || "");
        const companyAddress2 = safeTrim(activeSettings.company_address_2 || "");
        const companyPostcodeCity = [
          safeTrim(activeSettings.company_postcode || ""),
          safeTrim(activeSettings.company_city || ""),
        ].filter(Boolean).join(" ");
        const companyCountry = safeTrim(activeSettings.company_country || "");
        const companyEmail = safeTrim(activeSettings.company_email || "");
        const companyPhone = safeTrim(activeSettings.company_phone || "");
        const companyWebsite = safeTrim(activeSettings.company_website || "");
        const companyIban = safeTrim(activeSettings.company_iban || "");
        const companyGIban = safeTrim(activeSettings.company_g_iban || "");
        const gAccountPercentage = relationGAccountPercentage(selectedOrganisation);
        const logoUrl = safeTrim(activeSettings.logo_url || "");

        const placementVariables = {
          document_nummer: placementNo,
          relatie: relation || "de opdrachtgever",
          contactpersoon: contact || "",
          kandidaat: candidate || "de kandidaat",
          functie: form.job_title || "",
          startdatum: formatDateNL(form.start_date),
          einddatum: formatDateNL(form.end_date),
          bedrijfscode: companyCodeName(form),
        };

        const introText = replacePlacementVariables(
          activeSettings.intro_text || activeDefaults.intro_text,
          placementVariables
        );
        const customerClosing = "Wilt u de gegevens controleren en eventuele afwijkingen zo spoedig mogelijk aan ons doorgeven?";
        const candidateClosing = "Controleer de gegevens goed. Neem direct contact met ons op als iets niet klopt of als je nog vragen hebt.";
        const footerText = replacePlacementVariables(
          activeSettings.footer_text || activeDefaults.footer_text,
          placementVariables
        );

        const moneyText = (v, suffix = "") => {
          const raw = safeTrim(v);
          if (!raw) return "";
          return `${raw}${suffix}`;
        };

        const positiveMoney = (v) => {
          const n = parseDecimal(v);
          return Number.isFinite(n) && n > 0;
        };

        const travelUnitText = (unit) => unit === "day" ? "per dag" : "per km";

        const travelAmountText = (amount, unit) => {
          if (!positiveMoney(amount)) return "";
          return `€ ${formatDecimalInputValue(amount, 2)} ${travelUnitText(unit)}`;
        };

        const transportText = () => {
          if (form.company_transport === true) return "Vd Zaak";
          if (form.own_transport === true) return "Eigen";
          return "";
        };

        const showContent = (key) => activeSettings?.[key] !== false;

        const row = (label, value) => {
          const text = safeTrim(value);
          if (!text) return "";
          return `<tr><td>${htmlEscape(label)}</td><td>${htmlLines(text)}</td></tr>`;
        };

        const logoBlock = logoUrl
          ? `<img src="${htmlEscape(logoUrl)}" alt="${htmlEscape(companyName)}" style="max-width:190px; max-height:82px; object-fit:contain; display:block;" />`
          : `<div style="font-size:30px; font-weight:700; color:#0b4f7a; letter-spacing:.2px;">${htmlEscape(companyName)}</div>`;

        const companyLines = [companyAddress1, companyAddress2, companyPostcodeCity, companyCountry]
          .filter(Boolean)
          .map((x) => htmlEscape(x))
          .join("<br/>");

        const contactLines = [
          companyPhone ? `T ${htmlEscape(companyPhone)}` : "",
          companyEmail ? `E ${htmlEscape(companyEmail)}` : "",
          companyWebsite ? `W ${htmlEscape(companyWebsite)}` : "",
        ].filter(Boolean).join("<br/>");

        const recipientBlock = isCandidate
          ? `
            <div class="address-card">
              <div class="label">Kandidaat</div>
              <div class="recipient-name">${htmlLines(candidate)}</div>
            </div>
          `
          : `
            <div class="address-card">
              <div class="label">Relatie</div>
              <div class="recipient-name">${htmlLines(relation)}</div>
              ${contact ? `<div>t.a.v. ${htmlLines(contact)}</div>` : ""}
            </div>
          `;

        const locationText = safeTrim(form.location);

        return `
          <!doctype html>
          <html>
            <head>
              <meta charset="utf-8" />
              <title>${htmlEscape(title)} ${htmlEscape(placementNo)}</title>
              <style>
                @page { size: A4; margin: 14mm; }
                html, body {
                  margin: 0;
                  padding: 0;
                  background: #fff;
                  font-family: Arial, Helvetica, sans-serif;
                  color: #222;
                  font-size: 12px;
                  line-height: 1.45;
                }
                .wrap { width: 182mm; max-width: 182mm; margin: 0 auto; }
                .header { display: grid; grid-template-columns: 1.15fr .85fr; gap: 18px; align-items: start; margin-bottom: 24px; }
                .company { text-align: right; color: #444; font-size: 11px; line-height: 1.5; }
                .doc-title { background: #0b4f7a; color: #fff; padding: 11px 13px; font-size: 20px; font-weight: 700; margin: 0 0 18px 0; border-radius: 2px; }
                .topgrid { display: grid; grid-template-columns: 1.05fr .95fr; gap: 22px; margin-bottom: 18px; }
                .address-card { border-left: 4px solid #0b4f7a; padding: 8px 10px; background: #f7fafc; min-height: 54px; }
                .label { font-size: 10.5px; color: #666; text-transform: uppercase; letter-spacing: .05em; margin-bottom: 4px; }
                .recipient-name { font-weight: 700; font-size: 13px; }
                .meta { border: 1px solid #e1e6ea; border-radius: 2px; padding: 8px 10px; background: #fff; }
                .intro { margin: 16px 0 16px 0; font-size: 12.5px; }
                h2 { font-size: 14px; margin: 21px 0 8px 0; color: #0b4f7a; border-bottom: 1px solid #d9d9d9; padding-bottom: 4px; }
                p { margin: 0 0 12px 0; }
                table { width: 100%; border-collapse: collapse; margin-top: 8px; }
                td { padding: 6px 8px; border-bottom: 1px solid #ededed; vertical-align: top; }
                td:first-child { width: 35%; font-weight: 700; color: #444; background: #fafafa; }
                .notice { margin-top: 10px; padding: 10px 12px; background: #f6f8fa; border-left: 4px solid #0b4f7a; }
                .closing { margin-top: 22px; }
                .signature { margin-top: 18px; }
                .footer { margin-top: 28px; padding-top: 10px; border-top: 1px solid #d9d9d9; color: #666; font-size: 11px; }
                button { display: none !important; }
              </style>
            </head>
            <body>
              <div class="wrap">
                <div class="header">
                  <div>${logoBlock}</div>
                  <div class="company">
                    ${companyLines}
                    ${companyLines && contactLines ? "<br/>" : ""}
                    ${contactLines}
                  </div>
                </div>

                <div class="doc-title">${htmlEscape(title)}</div>

                <div class="topgrid">
                  <div>${recipientBlock}</div>
                  <div class="meta">
                    <div class="label">Documentdatum</div>
                    <div>${htmlLines(today)}</div>
                    <br/>
                    <div class="label">Plaatsing</div>
                    <div>${htmlLines(placementNo)}</div>
                  </div>
                </div>

                <div class="intro">${introText}</div>

                <h2>Plaatsingsgegevens</h2>
                <table>
                  <tbody>
                    ${showContent("show_function") ? row("Functie", form.job_title) : ""}
                    ${showContent("show_relation") ? (isCandidate ? row("Opdrachtgever", relation) : row("Relatie", relation)) : ""}
                    ${showContent("show_contact") ? (isCandidate ? row("Contactpersoon opdrachtgever", contact) : row("Contactpersoon", contact)) : ""}
                    ${showContent("show_candidate") ? row("Kandidaat", candidate) : ""}
                    ${showContent("show_start_date") ? row("Startdatum", formatDateNL(form.start_date)) : ""}
                    ${showContent("show_end_date") ? row("Einddatum", formatDateNL(form.end_date)) : ""}
                    ${showContent("show_notice_period") ? row("Opzegtermijn", form.notice_period) : ""}
                    ${showContent("show_hours_per_week") ? row("Uren per week", form.hours_per_week) : ""}
                    ${showContent("show_schedule") ? row("Dagdeel", `${form.plan_morning === true ? "Ochtend" : ""}${form.plan_morning === true && form.plan_afternoon === true ? " + " : ""}${form.plan_afternoon === true ? "Middag" : ""}`) : ""}
                    ${showContent("show_weekends") ? row("Doorplannen in het weekend", form.plan_weekends === true ? "Ja" : "Nee") : ""}
                    ${showContent("show_schedule") ? row("Werktijden / rooster", form.schedule_text) : ""}
                    ${showContent("show_location") ? row("Locatie / bezoekadres", locationText) : ""}
                    ${showContent("show_location_contact") ? row("Contact op locatie", form.location_contact) : ""}
                    ${showContent("show_registration_procedure") ? row("Aanmeldprocedure", form.registration_procedure) : ""}
                  </tbody>
                </table>

                <h2>${isCandidate ? "Afspraken kandidaat" : "Overige afspraken"}</h2>
                <table>
                  <tbody>
                    ${["Vast", "Tijdelijk"].includes(form.employment_type || "Vast") && showContent("show_cao") ? row("CAO", form.cao) : ""}
                    ${showContent("show_employment_type") ? row("Inzetvorm", form.employment_type || "Vast") : ""}
                    ${isCandidate && ["ZZP", "Doorleen"].includes(form.employment_type || "Vast") ? row("Bedrijf / leverancier", form.supplier_name) : ""}
                    ${["Vast", "Tijdelijk"].includes(form.employment_type || "Vast") && showContent("show_wage_period") ? row("Loonperiode", form.wage_period) : ""}
                    ${isCandidate && showContent("show_hourly_wage")
                      ? (
                          ["ZZP", "Doorleen"].includes(form.employment_type || "Vast")
                            ? row("Tarief", moneyText(form.purchase_rate, " excl. btw"))
                            : row("Uurloon", moneyText(form.hourly_wage))
                        )
                      : ""}
                    ${showContent("show_transport") ? row("Vervoer", transportText()) : ""}
                    ${isCandidate && showContent("show_travel_costs")
                      ? row("Reiskostenvergoeding", travelAmountText(form.travel_costs, form.travel_costs_unit))
                      : ""}
                    ${!isCandidate && showContent("show_invoice_period") ? row("Factuurperiode", form.invoice_period) : ""}
                    ${!isCandidate && showContent("show_sales_rate") ? row("Verkooptarief", moneyText(form.sales_rate, " excl. btw")) : ""}
                    ${!isCandidate && showContent("show_factor") ? row("Factor", form.factor) : ""}
                    ${!isCandidate && form.charge_travel_costs === true && showContent("show_customer_travel_costs")
                      ? row("Reiskosten klant", travelAmountText(form.charge_travel_costs_amount, form.charge_travel_costs_unit))
                      : ""}
                    ${!isCandidate ? row("IBAN", companyIban) : ""}
                    ${!isCandidate && companyGIban && gAccountPercentage > 0 ? row("G-rekening", companyGIban) : ""}
                    ${!isCandidate && companyGIban && gAccountPercentage > 0 ? row("Te voldoen op G-rekening", `${formatDecimalInputValue(gAccountPercentage, 2)}%`) : ""}
                    ${showContent("show_allowances") ? row("Toeslagen", form.allowances) : ""}
                    ${!isCandidate && showContent("show_invoice_agreement") ? row("Factuurafspraak", form.invoice_agreement) : ""}
                  </tbody>
                </table>

                ${form.external_note && showContent("show_external_note") ? `
                  <h2>Opmerking</h2>
                  <div class="notice">${htmlLines(form.external_note)}</div>
                ` : ""}

                <p class="closing">${htmlEscape(isCandidate ? candidateClosing : customerClosing)}</p>

                <div class="signature">
                  Met vriendelijke groet,<br/>
                  ${htmlEscape(companyName || "StaffIQ")}
                </div>

                <div class="footer">
                  ${footerText}
                </div>
              </div>
            </body>
          </html>
        `;
      }

      function previewPlacementConfirmation(kind) {
        if (!form.id) {
          setSaveError("Sla de plaatsing eerst op voordat je een bevestiging maakt.");
          return;
        }

        const html = buildPlacementPrintHtml(kind);
        const w = window.open("", "_blank", "width=1000,height=800");

        if (!w) {
          setSaveError("Popup kon niet worden geopend.");
          return;
        }

        w.document.open();
        w.document.write(html);
        w.document.close();
        w.focus();
      }

      async function savePlacementConfirmation(kind, options = {}) {
        if (isReadonlyRole) return;

        if (!form.id) {
          setSaveError("Sla de plaatsing eerst op voordat je een bevestiging opslaat.");
          return;
        }

        setSaveError(null);

        try {
          const html = buildPlacementPrintHtml(kind);
          const result = await tryFetchJson([`/api/placements/${encodeURIComponent(form.id)}/save-document-html`, `/api/plaatsingen/${encodeURIComponent(form.id)}/save-document-html`], {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ html, kind }),
          });

          const docId = result?.document?.id ? ` (#${result.document.id})` : "";
          const actionText = "opgeslagen";

          setSavedConfirmations((prev) => ({
            ...prev,
            [kind === "candidate" ? "candidate" : "customer"]: true,
          }));

          if (!options.silent) {
            const msg = kind === "candidate"
              ? `Bevestiging kandidaat ${actionText} bij documenten${docId} ✅`
              : `Bevestiging klant ${actionText} bij documenten${docId} ✅`;

            setFlash(msg);
            alert(msg);
            setTimeout(() => setFlash(""), 2200);
          }

          return result;
        } catch (e) {
          setSaveError(e?.message || String(e));
        }
      }

      async function mailPlacementConfirmation(kind) {
        if (isReadonlyRole) return;

        if (!form.id) {
          setSaveError("Sla de plaatsing eerst op voordat je een bevestiging mailt.");
          return;
        }

        // Het scherm probeert het e-mailadres alvast te bepalen.
        // Kandidaatbevestiging gaat naar personeel.
        // Klantbevestiging gaat naar het bedrijf/de relatie, niet naar de contactpersoon.
        const to = kind === "candidate" ? currentCandidateEmail() : currentCustomerEmail();

        setSaveError(null);

        try {
          const html = buildPlacementPrintHtml(kind);
          const result = await tryFetchJson([`/api/placements/${encodeURIComponent(form.id)}/send-email`, `/api/plaatsingen/${encodeURIComponent(form.id)}/send-email`], {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              to,
              kind,
              subject: replacePlacementVariables(
                kind === "candidate"
                  ? (
                      hrmPlacementCandidateSettings.email_subject ||
                      emptyHrmPlacementCandidateSettings.email_subject
                    )
                  : (
                      hrmPlacementCustomerSettings.email_subject ||
                      emptyHrmPlacementCustomerSettings.email_subject
                    ),
                {
                  document_nummer: form.placement_number || form.id || "",
                  relatie: relationName(form) || "",
                  contactpersoon: kind === "candidate"
                    ? displayPersonName(selectedPersonnel, personName(form))
                    : displayContactName(selectedContact, pickContactName(selectedContact)),
                  kandidaat: displayPersonName(selectedPersonnel, personName(form)),
                  functie: form.job_title || "",
                  startdatum: formatDateNL(form.start_date),
                  einddatum: formatDateNL(form.end_date),
                  bedrijfscode: companyCodeName(form),
                }
              ),
              html,
            }),
          });

          const sentTo = result?.to || to || "ontvanger";
          const accepted = Array.isArray(result?.accepted) ? result.accepted.join(", ") : "";
          const rejected = Array.isArray(result?.rejected) ? result.rejected.join(", ") : "";
          const msg = result?.message || `Bevestiging verstuurd naar ${sentTo}`;

          alert(
            `${msg}` +
              `${accepted ? `
    Geaccepteerd door mailserver: ${accepted}` : ""}` +
              `${rejected ? `
    Niet geaccepteerd: ${rejected}` : ""}`
          );

          setFlash(`${msg} ✅`);
          setTimeout(() => setFlash(""), 2200);
        } catch (e) {
          setSaveError(e?.message || String(e));
        }
      }

      async function loadPlacementDocumentSetSummary(placementId) {
        if (!placementId) {
          setDocumentSetSummary({ completed: 0, total: 0, complete: false, started: false });
          return;
        }

        try {
          const instances = await tryFetchJson([
            `/api/document-set-instances?source_type=placement&source_id=${encodeURIComponent(placementId)}`,
          ]);

          const rows = Array.isArray(instances) ? instances : [];
          const completed = rows.reduce(
            (sum, inst) => sum + Number(inst?.progress_completed || 0),
            0
          );
          const total = rows.reduce(
            (sum, inst) => sum + Number(inst?.progress_total || 0),
            0
          );

          setDocumentSetSummary({
            completed,
            total,
            complete: rows.length > 0 && total > 0 && completed >= total,
            started: rows.length > 0,
          });
        } catch {
          setDocumentSetSummary({ completed: 0, total: 0, complete: false, started: false });
        }
      }

      async function loadPlacementDocumentSets(placementId = form.id || selectedId) {
        if (!placementId) return;

        setDocumentSetsBusy(true);
        setDocumentSetsError("");

        try {
          const personnelId = form.personnel_id || "";
          const [sets, instances, docs, personnelDocs] = await Promise.all([
            tryFetchJson(["/api/document-sets"]),
            tryFetchJson([
              `/api/document-set-instances?source_type=placement&source_id=${encodeURIComponent(placementId)}`,
            ]),
            tryFetchJson([
              `/api/documents?placement_id=${encodeURIComponent(placementId)}`,
            ]),
            personnelId
              ? tryFetchJson([
                  `/api/documents?personnel_id=${encodeURIComponent(personnelId)}`,
                ])
              : Promise.resolve([]),
          ]);

          setDocumentSets(
            (Array.isArray(sets) ? sets : []).filter(
              (x) =>
                x?.active !== false &&
                ["placement", "plaatsing"].includes(
                  String(x?.source_type || "").toLowerCase()
                )
            )
          );
          const instanceRows = Array.isArray(instances) ? instances : [];
          setDocumentSetInstances(instanceRows);

          const summaryCompleted = instanceRows.reduce(
            (sum, inst) => sum + Number(inst?.progress_completed || 0),
            0
          );
          const summaryTotal = instanceRows.reduce(
            (sum, inst) => sum + Number(inst?.progress_total || 0),
            0
          );
          setDocumentSetSummary({
            completed: summaryCompleted,
            total: summaryTotal,
            complete:
              instanceRows.length > 0 &&
              summaryTotal > 0 &&
              summaryCompleted >= summaryTotal,
            started: instanceRows.length > 0,
          });

          setPlacementDocuments(Array.isArray(docs) ? docs : []);
          setPersonnelDocumentsForSet(Array.isArray(personnelDocs) ? personnelDocs : []);
        } catch (e) {
          setDocumentSetsError(
            e?.message || "Documentsets konden niet worden geladen."
          );
        } finally {
          setDocumentSetsBusy(false);
        }
      }

      async function openPlacementDocumentSets() {
        const placementId = form.id || selectedId;

        if (!placementId) {
          setSaveError("Sla de plaatsing eerst op voordat je documentsets gebruikt.");
          return;
        }

        setDocumentSetsOpen(true);
        await loadPlacementDocumentSets(placementId);
      }

      async function startPlacementDocumentSet(documentSetId) {
        const placementId = form.id || selectedId;
        if (!placementId) return;

        try {
          setDocumentSetsBusy(true);
          setDocumentSetsError("");

          await tryFetchJson(["/api/document-set-instances"], {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              document_set_id: documentSetId,
              source_type: "placement",
              source_id: String(placementId),
              source_label:
                form.placement_number ||
                [relationName(form), personName(form), form.job_title]
                  .filter(Boolean)
                  .join(" - "),
              company_code_id: form.company_code_id
                ? Number(form.company_code_id)
                : null,
            }),
          });

          await loadPlacementDocumentSets(placementId);
        } catch (e) {
          setDocumentSetsError(e?.message || "Documentset starten mislukt.");
          setDocumentSetsBusy(false);
        }
      }

      async function deletePlacementDocumentSetInstance(instance) {
        const placementId = form.id || selectedId;
        if (!placementId || !instance?.id || isReadonlyRole) return;

        const name = instance.document_set_name || "deze documentset";
        if (!window.confirm(`Documentset '${name}' verwijderen?\n\nDe gekoppelde documenten zelf blijven bewaard.`)) return;

        try {
          setDocumentSetsBusy(true);
          setDocumentSetsError("");

          await tryFetchJson([`/api/document-set-instances/${encodeURIComponent(instance.id)}`], {
            method: "DELETE",
          });

          await loadPlacementDocumentSets(placementId);
          await loadPlacementDocumentSetSummary(placementId);
        } catch (e) {
          setDocumentSetsError(e?.message || "Documentset verwijderen mislukt.");
          setDocumentSetsBusy(false);
        }
      }

      function openDocumentFromPlacementSet(item) {
        const placementId = form.id || selectedId;
        if (!placementId) return;

        const lookupScope = String(item?.lookup_scope || "current").toLowerCase();
        const params = new URLSearchParams();

        params.set("document_type", "placement");
        if (item?.document_type_id) params.set("document_type_id", String(item.document_type_id));
        if (form.organisation_id) params.set("organisation_id", String(form.organisation_id));
        if (form.personnel_id) params.set("personnel_id", String(form.personnel_id));
        if (form.company_code_id) params.set("company_code_id", String(form.company_code_id));

        // Documenten opent in koppelmodus. Daar kan de gebruiker een bestaand
        // passend document kiezen of eerst een nieuw document uploaden.
        params.set("document_set_item_id", String(item.id));
        params.set("return_placement_id", String(placementId));
        params.set("lookup_scope", lookupScope);

        if (lookupScope === "personnel") {
          params.set("source_module", "personnel");
          params.set("source_id", String(form.personnel_id || ""));
        } else {
          params.set("source_module", "placement");
          params.set("source_id", String(placementId));
        }

        try {
          sessionStorage.setItem("staffiq_reopen_placement_id", String(placementId));
          sessionStorage.setItem("staffiq_reopen_placement_documentsets", "1");
        } catch {}

        window.location.href = `/documenten?${params.toString()}`;
      }

      async function updatePlacementDocumentSetItem(item, patch = {}) {
        try {
          setDocumentSetsBusy(true);
          setDocumentSetsError("");

          await tryFetchJson([`/api/document-set-instance-items/${item.id}`], {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              document_id:
                patch.document_id !== undefined
                  ? patch.document_id
                  : item.document_id,
              document_received:
                patch.document_received !== undefined
                  ? patch.document_received
                  : item.document_received === true,
              signature_received:
                patch.signature_received !== undefined
                  ? patch.signature_received
                  : item.signature_received === true,
              note: item.note || "",
            }),
          });

          await loadPlacementDocumentSets(form.id || selectedId);
        } catch (e) {
          setDocumentSetsError(
            e?.message || "Documentset-onderdeel bijwerken mislukt."
          );
          setDocumentSetsBusy(false);
        }
      }

      function getFocusableElements() {
        return focusOrderRefs
          .map((r) => r.current)
          .filter((el) => el && !el.disabled && !el.readOnly);
      }

      function focusNextField(dir = +1) {
        const els = getFocusableElements();
        if (!els.length) return;
        const active = document.activeElement;
        let idx = els.findIndex((el) => el === active);
        if (idx === -1) idx = dir > 0 ? -1 : 0;
        const next = els[Math.max(0, Math.min(els.length - 1, idx + dir))];
        try {
          next?.focus?.();
          next?.select?.();
        } catch {}
      }

      const voice = useVoiceCommands({
        lang: "nl-NL",
        timeoutMs: 5000,
        onCommand: (cmd) => {
          if (!cmd?.type) return false;
          if (cmd.type === "next") return mode === "form" ? focusNextField(+1) : moveCursor(+1), true;
          if (cmd.type === "prev") return mode === "form" ? focusNextField(-1) : moveCursor(-1), true;
          if (cmd.type === "new") return newItem(), true;
          if (cmd.type === "refresh") return vernieuwList(), true;
          if (cmd.type === "save") return saveItem(), true;
          if (cmd.type === "delete") return deleteItem(), true;
          if (cmd.type === "select") return openCurrentRow(), true;
          return false;
        },
        onDictation: (text) => {
          const raw = String(text || "").trim();
          if (!raw) return;
          setSpeechInfo(`🎙 ${raw}`);
          setTimeout(() => setSpeechInfo(""), 2000);
          const t = norm(raw);
          if (t === "volgende") return mode === "form" ? focusNextField(+1) : moveCursor(+1);
          if (t === "vorige" || t === "terug") return mode === "form" ? focusNextField(-1) : moveCursor(-1);
          if (t === "nieuw") return newItem();
          if (t === "vernieuw" || t === "vernieuwen") return vernieuwList();
          if (t === "opslaan") return saveItem();
          if (t === "selecteer" || t === "item" || t === "rechts") return openCurrentRow();
          if (t === "lijst" || t === "links") return setMode("search");
          if (mode === "search") {
            if (isEmptyWord(raw)) setQ("");
            else setQ(raw);
          }
        },
      });

      const isMobile = window.innerWidth <= 768;
      const RIGHT_WIDTH = isMobile ? "100%" : 320;
      const GAP = isMobile ? 18 : 14;
      const TABLE_MIN_WIDTH = 1330;
      const MID_BOTTOM_OFFSET = isMobile ? 90 : 135;

      const colWidths = {
        date: 90,
        relation: 160,
        person: 160,
        function: 160,
        status: 100,
        order: 95,
        cao: 80,
        active: 70,
        companyCode: 115,
      };

      const searchInputStyle = {
        padding: "7px 10px",
        width: isMobile ? "100%" : 220,
        border: "1px solid #d9d9d9",
        borderRadius: 4,
        background: "white",
        outline: "none",
        boxSizing: "border-box",
      };

      const inputStyle = {
        display: "block",
        padding: "7px 10px",
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        border: "1px solid #d9d9d9",
        borderRadius: 4,
        background: "white",
        boxSizing: "border-box",
      };

      const selectStyle = {
        display: "block",
        height: 30,
        padding: "0 8px",
        border: "1px solid #d9d9d9",
        borderRadius: 4,
        background: "white",
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        boxSizing: "border-box",
      };

      const labelStyle = {
        display: "block",
        fontSize: 13,
        color: "#333",
        marginBottom: 3,
      };

      const sectionTitleStyle = {
        fontSize: 13,
        fontWeight: 700,
        opacity: 0.75,
        marginTop: 8,
      };

      const buttonStyle = {
        padding: "7px 12px",
        border: "1px solid #d9d9d9",
        borderRadius: 4,
        background: "white",
        cursor: "pointer",
        whiteSpace: "nowrap",
      };

      const buttonDisabledStyle = { ...buttonStyle, opacity: 0.55, cursor: "not-allowed" };

      const primaryButtonStyle = {
        ...buttonStyle,
        background: "#2f7dd1",
        color: "white",
        border: "1px solid rgba(0,0,0,0.05)",
      };

      const dangerButtonStyle = {
        ...buttonStyle,
        background: "#d64545",
        color: "white",
        border: "1px solid rgba(0,0,0,0.05)",
      };

      const successButtonStyle = {
        ...buttonStyle,
        background: "#198754",
        color: "white",
        border: "1px solid rgba(0,0,0,0.05)",
      };

      const neutralButtonStyle = {
        ...buttonStyle,
        background: "#6c757d",
        color: "white",
        border: "1px solid rgba(0,0,0,0.05)",
      };

      const warningButtonStyle = {
        ...buttonStyle,
        background: "#fd7e14",
        color: "white",
        border: "1px solid rgba(0,0,0,0.05)",
      };

      const documentSetsButtonStyle = {
        ...buttonStyle,
        background: "#c58b1a",
        color: "white",
        border: "1px solid rgba(0,0,0,0.05)",
      };

      const proposeButtonStyle = {
        ...buttonStyle,
        background: "#6f42c1",
        color: "white",
        border: "1px solid rgba(0,0,0,0.05)",
      };

      const confirmButtonStyle = {
        ...buttonStyle,
        background: "#0f766e",
        color: "white",
        border: "1px solid rgba(0,0,0,0.05)",
      };

      // Velden blijven wit, net als bij de andere programma's.
      const disabledStyle = null;

      const thBase = {
        textAlign: "left",
        fontSize: 12,
        color: "#444",
        fontWeight: 700,
        padding: "8px 6px",
        borderBottom: "1px solid #e6e6e6",
        whiteSpace: "nowrap",
        position: "sticky",
        top: 0,
        zIndex: 5,
        background: "#fff",
        userSelect: "none",
      };

      const thClickable = { ...thBase, cursor: "pointer" };

      const filterThStyle = {
        ...thBase,
        fontWeight: 400,
        padding: "6px 6px 8px 6px",
        borderBottom: "1px solid #ededed",
        top: 32,
        zIndex: 4,
        cursor: "default",
      };

      const tdStyle = {
        padding: "7px 6px",
        borderBottom: "1px solid #efefef",
        fontSize: 13,
        color: "#222",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      };

      const rowBgCursor = "#f3f7ff";
      const rowBgSelected = "#e6f0ff";

      function sortToggle(key) {
        setSort((cur) => {
          if (cur.key !== key) return { key, dir: "asc" };
          return { key, dir: cur.dir === "asc" ? "desc" : "asc" };
        });
      }

      function sortArrow(key) {
        if (sort.key !== key) return "";
        return sort.dir === "asc" ? " ▲" : " ▼";
      }

      function SortHeader({ label, k }) {
        return (
          <th style={thClickable} onClick={() => sortToggle(k)}>
            {label}{sortArrow(k)}
          </th>
        );
      }

      function FilterSelect({ value, onChange, options, includeYesNo = false, includeEmpty = true }) {
        return (
          <select
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onClick={stopGridClick}
            style={selectStyle}
          >
            <option value="">(alle)</option>
            {includeYesNo ? (
              <>
                <option value="j">j</option>
                <option value="n">n</option>
              </>
            ) : (
              <>
                {includeEmpty && <option value={EMPTY_VAL}>Leeg</option>}
                {(options || []).map((x) => (
                  <option key={x} value={x}>
                    {x}
                  </option>
                ))}
              </>
            )}
          </select>
        );
      }

      function todayIso() {
        return new Date().toISOString().slice(0, 10);
      }

      function processButtonStyle(baseStyle, disabled = false) {
        return {
          ...(disabled ? { ...baseStyle, opacity: 0.5, cursor: "not-allowed" } : baseStyle),
          width: "100%",
          minWidth: 0,
          minHeight: 32,
          padding: "6px 6px",
          boxSizing: "border-box",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          whiteSpace: "nowrap",
          textAlign: "center",
          lineHeight: 1.15,
          fontSize: 12,
          overflow: "hidden",
          textOverflow: "ellipsis",
        };
      }

      async function savePlacementProcessFields(fields, message, confirmText) {
        if (isReadonlyRole) return;

        if (!form.id) {
          setSaveError("Sla de plaatsing eerst op voordat je de status wijzigt.");
          return;
        }

        if (confirmText && !window.confirm(confirmText)) return;

        setSaveError(null);

        const nextForm = {
          ...form,
          ...fields,
        };

        const payload = {
          ...nextForm,
          order_id: nextForm.order_id ? Number(nextForm.order_id) : null,
          hours_per_week: parseDecimal(nextForm.hours_per_week),
          factor: parseDecimal(nextForm.factor),
          hourly_wage: parseDecimal(nextForm.hourly_wage),
          employment_type: nextForm.employment_type || "Vast",
          purchase_rate: parseDecimal(nextForm.purchase_rate),
          rate_level: nextForm.rate_level || "",
          source_organisation_id: nextForm.source_organisation_id || null,
          supplier_name: nextForm.supplier_name || "",
          sales_rate: parseDecimal(nextForm.sales_rate),
          travel_costs: parseDecimal(nextForm.travel_costs),
          travel_hours_amount: parseDecimal(nextForm.travel_hours_amount),
          travel_costs_unit: nextForm.travel_costs_unit === "day" ? "day" : "km",
          own_transport: nextForm.own_transport === true,
          company_transport: nextForm.company_transport === true,
          charge_travel_costs: nextForm.charge_travel_costs === true,
          charge_travel_costs_unit: nextForm.charge_travel_costs_unit === "day" ? "day" : "km",
          charge_travel_costs_amount:
            nextForm.charge_travel_costs === true
              ? parseDecimal(nextForm.charge_travel_costs_amount)
              : null,
          customer_confirmed: nextForm.customer_confirmed === true,
          candidate_confirmed: nextForm.candidate_confirmed === true,
          plan_morning: nextForm.plan_morning === true,
          plan_afternoon: nextForm.plan_afternoon === true,
          plan_weekends: nextForm.plan_weekends === true,
          active: nextForm.active !== false,
        };

        try {
          const saved = await tryFetchJson(
            [`/api/placements/${nextForm.id}`, `/api/plaatsingen/${nextForm.id}`],
            {
              method: "PUT",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(payload),
            }
          );

          const normalized = normalizePlacement(saved);
          setForm(normalized);
          setSelectedId(normalized.id);
          setMode("form");
          setFlash(`${message} ✅`);
          setTimeout(() => setFlash(""), 1800);
          await loadList(true);
          setTimeout(() => {
            try { rightScrollRef.current?.scrollTo?.({ top: rightScrollRef.current?.scrollTop || 0, behavior: "auto" }); } catch {}
          }, 80);
        } catch (e) {
          setSaveError(e?.message || String(e));
        }
      }

      function markProposed() {
        savePlacementProcessFields(
          {
            status: "Voorgesteld",
            candidate_status: "Voorgesteld",
            customer_status: "In behandeling",
          },
          "Plaatsing voorgesteld",
          "Plaatsing op Voorgesteld zetten?"
        );
      }

      function markCandidateConfirmed() {
        const customerAlreadyOk = form.customer_confirmed === true;

        savePlacementProcessFields(
          {
            status: customerAlreadyOk ? "Bevestigd" : "Voorgesteld",
            candidate_confirmed: true,
            candidate_status: "Akkoord",
            customer_status: customerAlreadyOk ? "Akkoord" : (form.customer_status || "In behandeling"),
          },
          customerAlreadyOk ? "Kandidaat akkoord. Plaatsing is nu bevestigd" : "Kandidaat akkoord",
          "Kandidaat akkoord zetten?"
        );
      }

      function markCustomerConfirmed() {
        const candidateAlreadyOk = form.candidate_confirmed === true;

        savePlacementProcessFields(
          {
            status: candidateAlreadyOk ? "Bevestigd" : "Voorgesteld",
            customer_confirmed: true,
            customer_status: "Akkoord",
            candidate_status: candidateAlreadyOk ? "Akkoord" : (form.candidate_status || "Voorgesteld"),
          },
          candidateAlreadyOk ? "Klant akkoord. Plaatsing is nu bevestigd" : "Klant akkoord",
          "Klant akkoord zetten?"
        );
      }

      function markConfirmed() {
        if (form.candidate_confirmed !== true || form.customer_confirmed !== true) {
          alert("Bevestigen kan pas als kandidaat én klant akkoord zijn.");
          return;
        }

        savePlacementProcessFields(
          {
            status: "Bevestigd",
            candidate_status: "Akkoord",
            customer_status: "Akkoord",
          },
          "Plaatsing bevestigd. Bevestigingen kunnen nu worden aangemaakt",
          "Plaatsing bevestigen?"
        );
      }

      function markStarted() {
        savePlacementProcessFields(
          {
            status: "Gestart",
            candidate_status: "Gestart",
            customer_status: "Gestart",
          },
          "Plaatsing gestart",
          "Plaatsing starten?"
        );
      }

      function markStopped() {
        savePlacementProcessFields(
          {
            status: "Gestopt",
            end_date: form.end_date || todayIso(),
            candidate_status: "Gestopt",
            customer_status: "Gestopt",
          },
          "Plaatsing gestopt",
          "Plaatsing stoppen?"
        );
      }

      function markCancelled() {
        savePlacementProcessFields(
          {
            status: "Geannuleerd",
            candidate_status: "Geannuleerd",
            customer_status: "Geannuleerd",
          },
          "Plaatsing geannuleerd",
          "Plaatsing annuleren?"
        );
      }

      const currentPlacementStatusNorm = norm(form.status || "Concept");
      const hasSavedPlacement = !!form.id;
      const statusActionDisabled = isReadonlyRole || mode !== "form" || !hasSavedPlacement;
      const isConceptStatus = currentPlacementStatusNorm === "concept" || currentPlacementStatusNorm === "";
      const isProposedStatus = currentPlacementStatusNorm === "voorgesteld";
      const isConfirmedStatus = currentPlacementStatusNorm === "bevestigd";
      const isStartedStatus = currentPlacementStatusNorm === "gestart";
      const isStoppedStatus = currentPlacementStatusNorm === "gestopt";
      const isCancelledStatus = currentPlacementStatusNorm === "geannuleerd";
      const hasBothConfirmed = form.candidate_confirmed === true && form.customer_confirmed === true;
      const isFinalStatus = isStartedStatus || isStoppedStatus || isCancelledStatus;

      const canPropose = !statusActionDisabled && isConceptStatus;
      const canPreviewDocuments = hasSavedPlacement;
      const canSaveCustomerDocument = !isReadonlyRole && hasSavedPlacement && !isFinalStatus && savedConfirmations.customer !== true;
      const canSaveCandidateDocument = !isReadonlyRole && hasSavedPlacement && !isFinalStatus && savedConfirmations.candidate !== true;
      const customerApprovalPref = getPlacementApprovalPreference("customer");
      const candidateApprovalPref = getPlacementApprovalPreference("candidate");
      const canAskCustomerApproval =
        !isReadonlyRole &&
        hasSavedPlacement &&
        !isFinalStatus &&
        !sendingApproval &&
        form.customer_confirmed !== true;
      const canAskCandidateApproval =
        !isReadonlyRole &&
        hasSavedPlacement &&
        !isFinalStatus &&
        !sendingApproval &&
        form.candidate_confirmed !== true;
      const canStartPlacement = !statusActionDisabled && !isFinalStatus && (hasBothConfirmed || isConfirmedStatus);
      const canCancelPlacement = !statusActionDisabled && !isStoppedStatus && !isCancelledStatus;

      return (
        <div>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: isMobile ? "1fr" : `minmax(0, 1fr) ${RIGHT_WIDTH}px`,
              columnGap: GAP,
              rowGap: isMobile ? 22 : 0,
              alignItems: "start",
              minWidth: 0,
            }}
          >
            <div style={{ minWidth: 0 }}>
              <div
                ref={pageTopRef}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  marginTop: 0,
                  marginBottom: 10,
                }}
              >
                <h1 style={{ margin: 0 }}>
                  Plaatsingen <span style={{ fontSize: 12, opacity: 0.5 }}>{VERSION}</span>
                </h1>

                <HelpButton
                  topic="plaatsingen"
                  title="Help over Plaatsingen"
                />
              </div>
              {!isMobile ? (
                <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "nowrap" }}>
                  <input
                    ref={searchRef}
                    value={q}
                    onChange={(e) => {
                      setQ(e.target.value);
                      setMode("search");
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") loadList(false);
                    }}
                    placeholder="Zoek..."
                    style={searchInputStyle}
                  />

                  <div
                    title={`Aantal regels in het grid: ${gridCount}`}
                    style={{
                      minWidth: 52,
                      height: 32,
                      padding: "0 10px",
                      border: "1px solid #d9d9d9",
                      borderRadius: 4,
                      background: "#f7fafc",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 13,
                      fontWeight: 700,
                      color: "#1f4e79",
                      boxSizing: "border-box",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {gridCount}
                  </div>

                  <button
                    type="button"
                    onMouseDown={(e) => e.preventDefault()}
                    onTouchStart={(e) => e.preventDefault()}
                    onClick={() => (voice.startOnce || voice.start)?.()}
                    disabled={!voice.supported || voice.listening}
                    style={!voice.supported || voice.listening ? buttonDisabledStyle : buttonStyle}
                  >
                    {voice.listening ? "🎤 Luistert..." : "🎤 Spreek"}
                  </button>

                  <button
                    type="button"
                    onClick={newItem}
                    disabled={isReadonlyRole}
                    style={isReadonlyRole ? buttonDisabledStyle : buttonStyle}
                  >
                    ➕ Nieuw
                  </button>

                  <button type="button" onClick={vernieuwList} style={buttonStyle}>
                    🔄 Vernieuw
                  </button>
                </div>
              ) : (
                <>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "minmax(0, 1fr) 58px",
                      gap: 6,
                      marginBottom: 8,
                      alignItems: "center",
                    }}
                  >
                    <input
                      ref={searchRef}
                      value={q}
                      onChange={(e) => {
                        setQ(e.target.value);
                        setMode("search");
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") loadList(false);
                      }}
                      placeholder="Zoek..."
                      style={{ ...searchInputStyle, width: "100%", minWidth: 0 }}
                    />

                    <div
                      title={`Aantal regels in het grid: ${gridCount}`}
                      style={{
                        height: 34,
                        minHeight: 34,
                        padding: "0 8px",
                        border: "1px solid #d9d9d9",
                        borderRadius: 4,
                        background: "#f7fafc",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 13,
                        fontWeight: 700,
                        color: "#1f4e79",
                        boxSizing: "border-box",
                        whiteSpace: "nowrap",
                        lineHeight: "1",
                      }}
                    >
                      {gridCount}
                    </div>
                  </div>

                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 6, marginTop: 8 }}>
                    <button
                      type="button"
                      onClick={() => (voice.startOnce || voice.start)?.()}
                      disabled={!voice.supported || voice.listening}
                      style={!voice.supported || voice.listening ? buttonDisabledStyle : buttonStyle}
                    >
                      {voice.listening ? "🎤..." : "🎤 Spreek"}
                    </button>

                    <button
                      type="button"
                      onClick={newItem}
                      disabled={isReadonlyRole}
                      style={isReadonlyRole ? buttonDisabledStyle : buttonStyle}
                    >
                      ➕ Nieuw
                    </button>

                    <button type="button" onClick={vernieuwList} style={buttonStyle}>
                      🔄 Vernieuw
                    </button>
                  </div>
                </>
              )}

              <div style={{ marginTop: 10 }}>
                {loading && <div>Laden...</div>}
                {error && <div style={{ color: "crimson" }}>{error}</div>}
                {saveError && <div style={{ marginBottom: 8, color: "crimson" }}>{saveError}</div>}
                {flash && <div style={{ marginBottom: 8, color: "green" }}>{flash}</div>}
                {lastApprovalInfo?.approval_url && (
                  <div style={{ marginBottom: 8, color: "#1f4e79", lineHeight: 1.45 }}>
                    Akkoordlink gemaakt.
                    <br />
                    Document: plaatsingsbevestiging {approvalKindLabel(lastApprovalInfo.kind)}
                    <br />
                    Verzonden via: {approvalChannelLabel(lastApprovalInfo.channel)}
                    <br />
                    Verzonden door: {lastApprovalInfo.sent_by_name || "StaffIQ"}{lastApprovalInfo.sent_by_email ? ` (${lastApprovalInfo.sent_by_email})` : ""}
                    <br />
                    Ontvangen door: {lastApprovalInfo.sent_to_name || "-"}{lastApprovalInfo.sent_to ? ` (${lastApprovalInfo.sent_to})` : ""}
                    {lastApprovalInfo.email_to && (
                      <>
                        <br />
                        E-mail verstuurd naar: {lastApprovalInfo.email_to}
                      </>
                    )}
                    {lastApprovalInfo.email_accepted && (
                      <>
                        <br />
                        Geaccepteerd door mailserver: {lastApprovalInfo.email_accepted}
                      </>
                    )}
                    {lastApprovalInfo.email_rejected && (
                      <>
                        <br />
                        <span style={{ color: "#9b1c1c", fontWeight: 700 }}>
                          Niet geaccepteerd: {lastApprovalInfo.email_rejected}
                        </span>
                      </>
                    )}
                    {lastApprovalInfo.popup_blocked && (
                      <>
                        <br />
                        <span style={{ color: "#9b1c1c", fontWeight: 700 }}>
                          WhatsApp kon niet automatisch worden geopend. Gebruik de link hieronder.
                        </span>
                      </>
                    )}
                    <br />
                    <button
                      type="button"
                      onClick={() => {
                        window.open(lastApprovalInfo.approval_url, "_blank", "noopener,noreferrer");
                        setLastApprovalInfo(null);
                      }}
                      style={{ border: "none", background: "transparent", color: "#1f4e79", textDecoration: "underline", cursor: "pointer", padding: 0 }}
                    >
                      Open akkoordpagina
                    </button>
                    {lastApprovalInfo?.whatsapp_url && lastApprovalInfo.channel !== "email" && (
                      <>
                        <br />
                        <button
                          type="button"
                          onClick={() => openWhatsAppSmart(lastApprovalInfo.whatsapp_url)}
                          style={{ border: "none", background: "transparent", color: "#1f4e79", textDecoration: "underline", cursor: "pointer", padding: 0 }}
                        >
                          Open WhatsApp opnieuw
                        </button>
                      </>
                    )}
                  </div>
                )}
                {speechInfo && <div style={{ opacity: 0.75 }}>{speechInfo}</div>}
                {voice.error && voice.error !== "no-speech" && (
                  <div style={{ color: "crimson" }}>Spraakfout: {voice.error}</div>
                )}
              </div>

              <div style={{ marginTop: 8, minWidth: 0 }}>
                <div
                  style={{
                    overflowX: "scroll",
                    overflowY: "auto",
                    maxHeight: `calc(100vh - ${MID_BOTTOM_OFFSET}px)`,
                    border: "1px solid #f0f0f0",
                    borderRadius: 6,
                    background: "#fff",
                  }}
                >
                  <div style={{ minWidth: TABLE_MIN_WIDTH }}>
                    <table style={{ width: "100%", borderCollapse: "separate", borderSpacing: 0, tableLayout: "fixed" }}>
                      <colgroup>
                        <col style={{ width: colWidths.date }} />
                        <col style={{ width: colWidths.relation }} />
                        <col style={{ width: colWidths.person }} />
                        <col style={{ width: colWidths.function }} />
                        <col style={{ width: colWidths.status }} />
                        <col style={{ width: colWidths.order }} />
                        <col style={{ width: colWidths.cao }} />
                        <col style={{ width: colWidths.active }} />
                        <col style={{ width: colWidths.companyCode }} />
                      </colgroup>

                      <thead>
                        <tr>
                          <SortHeader label="Datum" k="date" />
                          <SortHeader label="Relatie" k="relation" />
                          <SortHeader label="Personeelslid" k="person" />
                          <SortHeader label="Functie" k="function" />
                          <SortHeader label="Status" k="status" />
                          <SortHeader label="Opdracht" k="order" />
                          <SortHeader label="CAO" k="cao" />
                          <th style={thClickable}>Actief</th>
                          <SortHeader label="Bedrijfscode" k="companyCode" />
                        </tr>

                        <tr>
                          <th style={filterThStyle}><FilterSelect value={dateFilter} onChange={setDateFilter} options={optionValues.date} /></th>
                          <th style={filterThStyle}><FilterSelect value={relationFilter} onChange={setRelationFilter} options={optionValues.relation} /></th>
                          <th style={filterThStyle}><FilterSelect value={personFilter} onChange={setPersonFilter} options={optionValues.person} /></th>
                          <th style={filterThStyle}><FilterSelect value={functionFilter} onChange={setFunctionFilter} options={optionValues.function} /></th>
                          <th style={filterThStyle}><FilterSelect value={statusFilter} onChange={setStatusFilter} options={optionValues.status} /></th>
                          <th style={filterThStyle}><FilterSelect value={orderFilter} onChange={setOrderFilter} options={optionValues.order} /></th>
                          <th style={filterThStyle}><FilterSelect value={caoFilter} onChange={setCaoFilter} options={optionValues.cao} /></th>
                          <th style={filterThStyle}><FilterSelect value={activeFilter} onChange={setActiveFilter} options={[]} includeYesNo /></th>
                          <th style={filterThStyle}><FilterSelect value={companyCodeFilter} onChange={setCompanyCodeFilter} options={optionValues.companyCode} includeEmpty={false} /></th>
                        </tr>
                      </thead>

                      <tbody>
                        {sorted.map((item, idx) => {
                          const isCursor = idx === listIndex;
                          const isSelected = String(selectedId || "") === String(item.id || "");

                          let bg = "transparent";
                          if (isSelected) bg = rowBgSelected;
                          else if (isCursor) bg = rowBgCursor;

                          return (
                            <tr
                              key={item.id}
                              ref={(el) => { rowRefs.current[idx] = el; }}
                              onClick={() => selectRow(item, idx)}
                              style={{ cursor: "pointer", backgroundColor: bg }}
                            >
                              <td style={tdStyle}>{formatDateNL(item.placement_date) || "-"}</td>
                              <td style={tdStyle} title={relationName(item)}>{relationName(item) || "-"}</td>
                              <td style={tdStyle} title={personName(item)}>{personName(item) || "-"}</td>
                              <td style={tdStyle} title={item.job_title || ""}>{item.job_title || "-"}</td>
                              <td style={tdStyle}>{item.status || "-"}</td>
                              <td style={tdStyle} title={orderReference(item)}>{orderReference(item) || "-"}</td>
                              <td style={tdStyle}>{item.cao || "-"}</td>
                              <td style={tdStyle}>{boolToJaNee(item.active !== false)}</td>
                              <td style={tdStyle} title={companyCodeName(item)}>{companyCodeName(item) || "-"}</td>
                            </tr>
                          );
                        })}

                        {sorted.length === 0 && (
                          <tr>
                            <td colSpan={9} style={{ padding: 12, opacity: 0.7 }}>
                              Geen plaatsingen gevonden.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div
              ref={rightScrollRef}
              style={{
                width: isMobile ? "100%" : RIGHT_WIDTH,
                minWidth: isMobile ? 0 : RIGHT_WIDTH,
                maxWidth: isMobile ? "100%" : RIGHT_WIDTH,
                position: isMobile ? "relative" : "sticky",
                top: isMobile ? "auto" : 0,
                alignSelf: "start",
                maxHeight: isMobile ? "none" : "calc(100vh - 40px)",
                overflowY: isMobile ? "visible" : "auto",
                background: "linear-gradient(180deg, #0b4f7a 0%, #083b5c 100%)",
                borderRadius: 10,
                padding: 10,
                paddingBottom: isMobile ? 34 : 10,
                boxSizing: "border-box",
                marginTop: isMobile ? 6 : 0,
                marginBottom: isMobile ? 34 : 0,
                paddingTop: isMobile ? 6 : 10,
              }}
            >
              <div
                style={{
                  background: "white",
                  borderRadius: 10,
                  padding: 12,
                  paddingBottom: isMobile ? 28 : 12,
                  boxSizing: "border-box",
                  width: "100%",
                  maxWidth: "100%",
                  minWidth: 0,
                  overflow: isMobile ? "visible" : "hidden",
                }}
              >
              <div style={{ marginBottom: 10 }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }}>
                  <h3 style={{ marginTop: 0, marginBottom: 0 }}>
                    {noteEditor === "internal_note"
                      ? "Opmerking intern"
                      : noteEditor === "external_note"
                        ? "Opmerking extern"
                        : "Plaatsing"}
                  </h3>

                  {noteEditor && (
                    <button
                      type="button"
                      onClick={closeNoteEditor}
                      style={buttonStyle}
                      title="Terug naar normaal formulier"
                    >
                      ↩ Terug
                    </button>
                  )}
                </div>
              </div>

              {saveError && <div style={{ color: "#b00020", marginBottom: 8 }}>{saveError}</div>}
              {flash && <div style={{ color: "#1f7a1f", marginBottom: 8 }}>{flash}</div>}

              {noteEditor ? (
                <div
                  style={{
                    display: "grid",
                    gridTemplateRows: "auto minmax(0, 1fr) auto",
                    gap: 10,
                    height: isMobile ? "auto" : "calc(100vh - 120px)",
                    maxHeight: isMobile ? "none" : "calc(100vh - 120px)",
                    minHeight: 0,
                  }}
                >
                  <div style={{ fontSize: 13, opacity: 0.8 }}>
                    Opmerking-editor (spreek: door-dicteren) — zeg <b>punt</b> voor “.”.
                  </div>

                  <textarea
                    ref={noteEditor === "internal_note" ? internalNoteBigRef : externalNoteBigRef}
                    value={form[noteEditor] || ""}
                    disabled={isFormLocked}
                    onChange={(e) => setField(noteEditor, e.target.value)}
                    rows={15}
                    style={{
                      padding: "10px 10px",
                      width: "100%",
                      height: isMobile ? "50vh" : "100%",
                      minHeight: isMobile ? 320 : 0,
                      maxHeight: isMobile ? "60vh" : "100%",
                      border: "1px solid #d9d9d9",
                      borderRadius: 6,
                      background: "white",
                      resize: "vertical",
                      boxSizing: "border-box",
                      fontSize: 14,
                      lineHeight: 1.4,
                    }}
                  />

                  <div
                    style={{
                      background: "white",
                      paddingTop: 10,
                      marginTop: 6,
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: 10,
                      borderTop: "1px solid #eee",
                    }}
                  >
                    <button
                      onClick={saveItem}
                      disabled={isFormLocked}
                      style={processButtonStyle(primaryButtonStyle, isFormLocked)}
                    >
                      💾 Opslaan
                    </button>

                    <button
                      onClick={deleteItem}
                      disabled={isReadonlyRole || !form.id}
                      style={processButtonStyle(
                        dangerButtonStyle,
                        isReadonlyRole || !form.id
                      )}
                    >
                      🗑 Verwijderen
                    </button>
                  </div>
                </div>
              ) : (
              <>
              <Field label="Plaatsingsdatum">
                <input ref={dateRef} type="date" value={form.placement_date || ""} onChange={(e) => setField("placement_date", e.target.value)} disabled={isFormLocked} style={{ ...inputStyle, ...disabledStyle }} />
              </Field>

              <Field label="Plaatsingsreferentie">
                <input ref={numberRef} type="text" autoComplete="off" value={form.placement_number || ""} onChange={(e) => setField("placement_number", e.target.value)} disabled={isFormLocked} style={{ ...inputStyle, ...disabledStyle }} />
              </Field>

              <Field label="Status">
                <select ref={statusRef} value={form.status || ""} onChange={(e) => setMainStatus(e.target.value)} disabled={isFormLocked} style={{ ...inputStyle, ...disabledStyle }}>
                  <option>Concept</option>
                  <option>Voorgesteld</option>
                  <option>Bevestigd</option>
                  <option>Gestart</option>
                  <option>Gestopt</option>
                  <option>Geannuleerd</option>
                </select>
              </Field>

              <Field label="Aanvraag">
                <select
                  ref={applicationRef}
                  value={form.application_id || ""}
                  onChange={(e) => applyApplication(e.target.value)}
                  disabled={isFormLocked}
                  style={{ ...inputStyle, ...disabledStyle }}
                >
                  <option value="">-</option>
                  {applications.map((a) => <option key={a.id} value={a.id}>{applicationLabel(a)}</option>)}
                </select>
              </Field>

              <Field label="Vacature">
                <select ref={vacancyRef} value={form.vacancy_id || ""} onChange={(e) => { setField("vacancy_id", e.target.value); applyVacancy(e.target.value); }} disabled={isFormLocked} style={{ ...inputStyle, ...disabledStyle }}>
                  <option value="">-</option>
                  {vacancies.map((v) => <option key={v.id} value={v.id}>{vacancyLabel(v)}</option>)}
                </select>
              </Field>


              <Field label="Opdracht">
                <select
                  ref={orderRef}
                  value={form.order_id || ""}
                  disabled={isFormLocked}
                  onChange={(e) => applyOrderDefaults(e.target.value)}
                  style={selectStyle}
                >
                  <option value="">-</option>
                  {(orders || []).filter((o) => o?.active !== false).map((o) => {
                    const label = [safeTrim(o?.order_reference), safeTrim(o?.organisation_name)].filter(Boolean).join(" - ") || `Opdracht #${o?.id}`;
                    return <option key={o.id} value={o.id}>{label}</option>;
                  })}
                </select>
              </Field>

              <Field label="Relatie">
                <select ref={relationRef} value={form.organisation_id || ""} onChange={(e) => {
                  const org = (organisations || []).find((o) => String(orgIdOf(o)) === String(e.target.value));
                  setForm((f) => ({
                    ...f,
                    organisation_id: e.target.value,
                    contact_id: "",
                    company_code_id: org?.company_code_id || "",
                    company_code: org?.company_code || "",
                    company_code_name: org?.company_code_name || "",
                    location: safeTrim(f.location) || organisationVisitAddressText(org),
                    place: safeTrim(f.place) || organisationVisitPlace(org),
                    region: safeTrim(f.region) || organisationVisitRegion(org),
                  }));
                }} disabled={isFormLocked} style={{ ...inputStyle, ...disabledStyle }}>
                  <option value="">-</option>
                  {organisations.map((o) => <option key={orgIdOf(o)} value={orgIdOf(o)}>{pickOrgName(o)}</option>)}
                </select>
              </Field>

              <Field label="Contactpersoon">
                <select ref={contactRef} value={form.contact_id || ""} onChange={(e) => setField("contact_id", e.target.value)} disabled={isFormLocked} style={{ ...inputStyle, ...disabledStyle }}>
                  <option value="">-</option>
                  {contacts.map((c) => <option key={contactIdOf(c)} value={contactIdOf(c)}>{pickContactName(c)}</option>)}
                </select>
              </Field>

              <Field label="Personeelslid">
                <select ref={personnelRef} value={form.personnel_id || ""} onChange={(e) => applyPersonnel(e.target.value)} disabled={isFormLocked} style={{ ...inputStyle, ...disabledStyle }}>
                  <option value="">-</option>
                  {personnel.map((p) => <option key={p.id} value={p.id}>{personnelName(p)}</option>)}
                </select>
              </Field>

              <Field label="Functie">
                <input ref={functionRef} value={form.job_title || ""} onChange={(e) => setField("job_title", e.target.value)} disabled={isFormLocked} style={{ ...inputStyle, ...disabledStyle }} />
              </Field>

              <Field label="Bedrijfscode">
                <input
                  value={companyCodeName(form)}
                  readOnly
                  disabled
                  style={{ ...inputStyle, background: "white", color: "#333" }}
                />
              </Field>

              <div style={{ borderTop: "1px solid #e5e5e5", margin: "12px 0", paddingTop: 10 }}>
                <div style={sectionTitleStyle}>Periode / inzet</div>
              </div>

              <Field label="Startdatum">
                <input ref={startDateRef} type="date" value={form.start_date || ""} onChange={(e) => setField("start_date", e.target.value)} disabled={isFormLocked} style={{ ...inputStyle, ...disabledStyle }} />
              </Field>

              <Field label="Einddatum">
                <input ref={endDateRef} type="date" value={form.end_date || ""} onChange={(e) => setField("end_date", e.target.value)} disabled={isFormLocked} style={{ ...inputStyle, ...disabledStyle }} />
              </Field>
              <Field label="Opzegtermijn">
                <input ref={noticePeriodRef} type="text" value={form.notice_period || ""} onChange={(e) => setField("notice_period", e.target.value)} disabled={isFormLocked} style={{ ...inputStyle, ...disabledStyle }} />
              </Field>

              <Field label="Uren per week">
                <input ref={hoursRef} inputMode="decimal" value={form.hours_per_week || ""} onChange={(e) => setDecimalField("hours_per_week", e.target.value)} onBlur={() => blurDecimalField("hours_per_week", 2)} disabled={isFormLocked} style={{ ...inputStyle, ...disabledStyle }} />
              </Field>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
                <Field label="Ochtend">
                  <select
                    ref={morningRef}
                    value={form.plan_morning === true ? "j" : "n"}
                    onChange={(e) => {
                      const next = e.target.value === "j";
                      if (!next && form.plan_afternoon !== true) {
                        setSaveError("Minimaal één dagdeel moet op Ja staan.");
                        return;
                      }
                      setSaveError(null);
                      setField("plan_morning", next);
                    }}
                    disabled={isFormLocked}
                    style={{ ...inputStyle, ...disabledStyle }}
                  >
                    <option value="j">Ja</option>
                    <option value="n">Nee</option>
                  </select>
                </Field>

                <Field label="Middag">
                  <select
                    ref={afternoonRef}
                    value={form.plan_afternoon === true ? "j" : "n"}
                    onChange={(e) => {
                      const next = e.target.value === "j";
                      if (!next && form.plan_morning !== true) {
                        setSaveError("Minimaal één dagdeel moet op Ja staan.");
                        return;
                      }
                      setSaveError(null);
                      setField("plan_afternoon", next);
                    }}
                    disabled={isFormLocked}
                    style={{ ...inputStyle, ...disabledStyle }}
                  >
                    <option value="j">Ja</option>
                    <option value="n">Nee</option>
                  </select>
                </Field>
              </div>

              <Field label="Doorplannen in het weekend">
                <select
                  ref={weekendRef}
                  value={form.plan_weekends === true ? "j" : "n"}
                  onChange={(e) => setField("plan_weekends", e.target.value === "j")}
                  disabled={isFormLocked}
                  style={{ ...inputStyle, ...disabledStyle }}
                >
                  <option value="n">Nee</option>
                  <option value="j">Ja</option>
                </select>
              </Field>

              <Field label="Werktijden / rooster">
                <textarea ref={scheduleRef} value={form.schedule_text || ""} onChange={(e) => setField("schedule_text", e.target.value)} disabled={isFormLocked} rows={2} style={{ ...inputStyle, ...disabledStyle }} />
              </Field>

              <Field label="Locatie / bezoekadres">
                <textarea ref={locationRef} value={form.location || ""} onChange={(e) => setField("location", e.target.value)} disabled={isFormLocked} rows={4} style={{ ...inputStyle, ...disabledStyle, resize: "vertical" }} />
              </Field>

              <Field label="Contact op locatie">
                <input ref={locationContactRef} value={form.location_contact || ""} onChange={(e) => setField("location_contact", e.target.value)} disabled={isFormLocked} style={{ ...inputStyle, ...disabledStyle }} />
              </Field>

              <Field label="Aanmeldprocedure">
                <textarea ref={registrationProcedureRef} value={form.registration_procedure || ""} onChange={(e) => setField("registration_procedure", e.target.value)} disabled={isFormLocked} rows={3} style={{ ...inputStyle, ...disabledStyle, resize: "vertical" }} />
              </Field>

              <Field label="Regio">
                <input ref={regionRef} value={form.region || ""} onChange={(e) => setField("region", e.target.value)} disabled={isFormLocked} style={{ ...inputStyle, ...disabledStyle }} />
              </Field>

              <div style={{ borderTop: "1px solid #e5e5e5", margin: "12px 0", paddingTop: 10 }}>
                <div style={sectionTitleStyle}>Tarieven / afspraken</div>
              </div>

              <Field label="CAO">
                <input ref={caoRef} value={form.cao || ""} onChange={(e) => setField("cao", e.target.value)} disabled={isFormLocked} style={{ ...inputStyle, ...disabledStyle }} />
              </Field>

              <Field label="Loonperiode">
                <select ref={wagePeriodRef} value={form.wage_period || ""} onChange={(e) => setField("wage_period", e.target.value)} disabled={isFormLocked} style={{ ...inputStyle, ...disabledStyle }}>
                  <option value="week">week</option>
                  <option value="4-weken">4-weken</option>
                  <option value="maand">maand</option>
                </select>
              </Field>

              <Field label="Factuurperiode">
                <select ref={invoicePeriodRef} value={form.invoice_period || ""} onChange={(e) => setField("invoice_period", e.target.value)} disabled={isFormLocked} style={{ ...inputStyle, ...disabledStyle }}>
                  <option value="week">week</option>
                  <option value="4-weken">4-weken</option>
                  <option value="maand">maand</option>
                </select>
              </Field>

              <Field label="Factor">
                <input ref={factorRef} inputMode="decimal" value={form.factor || ""} onChange={(e) => setDecimalField("factor", e.target.value)} onBlur={() => blurDecimalField("factor", 2)} disabled={isFormLocked} style={{ ...inputStyle, ...disabledStyle }} />
              </Field>

              <Field label="Inzetvorm">
                <select
                  ref={employmentTypeRef}
                  value={form.employment_type || "Vast"}
                  onChange={(e) => setField("employment_type", e.target.value)}
                  disabled={isFormLocked}
                  style={{ ...inputStyle, ...disabledStyle }}
                >
                  <option value="Vast">Vast</option>
                  <option value="Tijdelijk">Tijdelijk</option>
                  <option value="ZZP">ZZP</option>
                  <option value="Doorleen">Doorleen</option>
                </select>
              </Field>

              {["Vast", "Tijdelijk"].includes(form.employment_type || "Vast") ? (
                <Field label="Uurloon">
                  <input
                    ref={wageRef}
                    inputMode="decimal"
                    value={form.hourly_wage || ""}
                    onChange={(e) => setDecimalField("hourly_wage", e.target.value)}
                    onBlur={() => blurDecimalField("hourly_wage", 2)}
                    disabled={isFormLocked}
                    style={{ ...inputStyle, ...disabledStyle }}
                  />
                </Field>
              ) : (
                <>
                  <Field label="Bedrijf / leverancier">
                    <input
                      value={form.supplier_name || ""}
                      onChange={(e) => setField("supplier_name", e.target.value)}
                      disabled={isFormLocked}
                      style={{ ...inputStyle, ...disabledStyle }}
                    />
                  </Field>
                  <Field label="Inkooptarief">
                    <input
                      ref={purchaseRateRef}
                      inputMode="decimal"
                      value={form.purchase_rate || ""}
                      onChange={(e) => setDecimalField("purchase_rate", e.target.value)}
                      onBlur={() => blurDecimalField("purchase_rate", 2)}
                      disabled={isFormLocked}
                      style={{ ...inputStyle, ...disabledStyle }}
                    />
                  </Field>
                </>
              )}

              <Field label="Reiskostenvergoeding">
                <div style={{ display: "grid", gridTemplateColumns: "minmax(0, 1fr) 110px", gap: 6 }}>
                  <input
                    ref={travelCostsRef}
                    inputMode="decimal"
                    value={form.travel_costs || ""}
                    onChange={(e) => setDecimalField("travel_costs", e.target.value)}
                    onBlur={() => blurDecimalField("travel_costs", 2)}
                    disabled={isFormLocked}
                    style={{ ...inputStyle, ...disabledStyle, minWidth: 0 }}
                  />
                  <select
                    ref={travelCostsUnitRef}
                    value={form.travel_costs_unit || "km"}
                    onChange={(e) => setField("travel_costs_unit", e.target.value)}
                    disabled={isFormLocked}
                    style={{ ...inputStyle, ...disabledStyle, minWidth: 0 }}
                  >
                    <option value="km">per km</option>
                    <option value="day">per dag</option>
                  </select>
                </div>
              </Field>

              <Field label="Reisuren per dag">
                <input
                  ref={travelHoursAmountRef}
                  inputMode="decimal"
                  value={form.travel_hours_amount || ""}
                  onChange={(e) => setDecimalField("travel_hours_amount", e.target.value)}
                  onBlur={() => blurDecimalField("travel_hours_amount", 2)}
                  disabled={isFormLocked}
                  style={{ ...inputStyle, ...disabledStyle }}
                />
              </Field>

              <Field label="Vervoer">
                <div style={{ display: "flex", alignItems: "center", gap: 22, minHeight: 32 }}>
                  <label style={{ display: "flex", alignItems: "center", gap: 7, fontSize: 13 }}>
                    <input
                      ref={ownTransportRef}
                      type="checkbox"
                      checked={form.own_transport === true}
                      onChange={(e) =>
                        setForm((f) => ({
                          ...f,
                          own_transport: e.target.checked,
                          company_transport: e.target.checked ? false : f.company_transport,
                        }))
                      }
                      disabled={isFormLocked}
                    />
                    Eigen
                  </label>

                  <label style={{ display: "flex", alignItems: "center", gap: 7, fontSize: 13 }}>
                    <input
                      ref={companyTransportRef}
                      type="checkbox"
                      checked={form.company_transport === true}
                      onChange={(e) =>
                        setForm((f) => ({
                          ...f,
                          company_transport: e.target.checked,
                          own_transport: e.target.checked ? false : f.own_transport,
                        }))
                      }
                      disabled={isFormLocked}
                    />
                    Vd Zaak
                  </label>
                </div>
              </Field>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
                <Field label="Verkooptarief" labelMinHeight={32}>
                  <input
                    ref={salesRateRef}
                    inputMode="decimal"
                    value={form.sales_rate || ""}
                    onChange={(e) => setDecimalField("sales_rate", e.target.value)}
                    onBlur={() => blurDecimalField("sales_rate", 2)}
                    disabled={isFormLocked}
                    style={{ ...inputStyle, ...disabledStyle }}
                  />
                </Field>

                <Field label="Reiskosten doorberekenen" labelMinHeight={30}>
                  <select
                    ref={chargeTravelCostsRef}
                    value={form.charge_travel_costs === true ? "j" : "n"}
                    onChange={(e) =>
                      setForm((f) => ({
                        ...f,
                        charge_travel_costs: e.target.value === "j",
                        charge_travel_costs_amount:
                          e.target.value === "j" ? f.charge_travel_costs_amount : "",
                      }))
                    }
                    disabled={isFormLocked}
                    style={{ ...inputStyle, ...disabledStyle }}
                  >
                    <option value="n">Nee</option>
                    <option value="j">Ja</option>
                  </select>
                </Field>
              </div>

              {form.charge_travel_costs === true && (
                <Field label="Reiskosten klant">
                  <div style={{ display: "grid", gridTemplateColumns: "minmax(0, 1fr) 110px", gap: 6 }}>
                    <input
                      ref={chargeTravelCostsAmountRef}
                      inputMode="decimal"
                      value={form.charge_travel_costs_amount || ""}
                      onChange={(e) => setDecimalField("charge_travel_costs_amount", e.target.value)}
                      onBlur={() => blurDecimalField("charge_travel_costs_amount", 2)}
                      disabled={isFormLocked}
                      style={{ ...inputStyle, ...disabledStyle, minWidth: 0 }}
                    />
                    <select
                      ref={chargeTravelCostsUnitRef}
                      value={form.charge_travel_costs_unit || "km"}
                      onChange={(e) => setField("charge_travel_costs_unit", e.target.value)}
                      disabled={isFormLocked}
                      style={{ ...inputStyle, ...disabledStyle, minWidth: 0 }}
                    >
                      <option value="km">per km</option>
                      <option value="day">per dag</option>
                    </select>
                  </div>
                </Field>
              )}

              <Field label="Toeslagen">
                <textarea ref={allowancesRef} value={form.allowances || ""} onChange={(e) => setField("allowances", e.target.value)} disabled={isFormLocked} rows={2} style={{ ...inputStyle, ...disabledStyle }} />
              </Field>

              <Field label="Factuurafspraak">
                <textarea ref={invoiceAgreementRef} value={form.invoice_agreement || ""} onChange={(e) => setField("invoice_agreement", e.target.value)} disabled={isFormLocked} rows={2} style={{ ...inputStyle, ...disabledStyle }} />
              </Field>

              <div style={{ borderTop: "1px solid #e5e5e5", margin: "12px 0", paddingTop: 10 }}>
                <div style={sectionTitleStyle}>Proces</div>
              </div>

              <Field label="Status kandidaat">
                <input ref={candidateStatusRef} value={form.candidate_status || ""} onChange={(e) => setField("candidate_status", e.target.value)} disabled={isFormLocked} style={{ ...inputStyle, ...disabledStyle }} />
              </Field>

              <Field label="Status klant">
                <input ref={customerStatusRef} value={form.customer_status || ""} onChange={(e) => setField("customer_status", e.target.value)} disabled={isFormLocked} style={{ ...inputStyle, ...disabledStyle }} />
              </Field>

              <Field label="Opmerking intern">
                <textarea
                  ref={internalNoteRef}
                  value={form.internal_note || ""}
                  onChange={(e) => setField("internal_note", e.target.value)}
                  onFocus={() => {
                    if (ignoreNextNoteFocusRef.current === "internal_note") {
                      ignoreNextNoteFocusRef.current = "";
                      return;
                    }
                    openNoteEditor("internal_note");
                  }}
                  disabled={isFormLocked}
                  rows={3}
                  style={{ ...inputStyle, ...disabledStyle }}
                />
              </Field>

              <Field label="Opmerking extern">
                <textarea
                  ref={externalNoteRef}
                  value={form.external_note || ""}
                  onChange={(e) => setField("external_note", e.target.value)}
                  onFocus={() => {
                    if (ignoreNextNoteFocusRef.current === "external_note") {
                      ignoreNextNoteFocusRef.current = "";
                      return;
                    }
                    openNoteEditor("external_note");
                  }}
                  disabled={isFormLocked}
                  rows={3}
                  style={{ ...inputStyle, ...disabledStyle }}
                />
              </Field>

              <label style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 12 }}>
                <input type="checkbox" checked={form.active !== false} onChange={(e) => setField("active", e.target.checked)} disabled={isFormLocked} />
                Actief
              </label>

              <div
                style={{
                  borderTop: "1px solid #e5e5e5",
                  paddingTop: 10,
                  marginTop: 12,
                  width: "100%",
                  boxSizing: "border-box",
                }}
              >
                <div style={{ ...sectionTitleStyle, marginTop: 0, marginBottom: 8 }}>
                  Status / opvolging
                </div>

                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: 8,
                    width: "100%",
                    boxSizing: "border-box",
                    marginBottom: 8,
                  }}
                >
                  <button
                    type="button"
                    onClick={markProposed}
                    disabled={!canPropose}
                    style={processButtonStyle(proposeButtonStyle, !canPropose)}
                    title="Plaatsing op Voorgesteld zetten"
                  >
                    📤 Voorstellen
                  </button>

                  <button
                    type="button"
                    onClick={markCancelled}
                    disabled={!canCancelPlacement}
                    style={processButtonStyle(neutralButtonStyle, !canCancelPlacement)}
                    title="Plaatsing annuleren"
                  >
                    🚫 Annuleren
                  </button>

                  <button
                    type="button"
                    onClick={() => previewPlacementConfirmation("customer")}
                    disabled={!canPreviewDocuments}
                    style={processButtonStyle(neutralButtonStyle, !canPreviewDocuments)}
                  >
                    👁 Voorbeeld klant
                  </button>

                  <button
                    type="button"
                    onClick={() => previewPlacementConfirmation("candidate")}
                    disabled={!canPreviewDocuments}
                    style={processButtonStyle(neutralButtonStyle, !canPreviewDocuments)}
                  >
                    👁 Voorb kandidaat
                  </button>

                  <button
                    type="button"
                    onClick={() => savePlacementConfirmation("customer")}
                    disabled={!canSaveCustomerDocument}
                    style={processButtonStyle(confirmButtonStyle, !canSaveCustomerDocument)}
                  >
                    💾 Bevestigen klant
                  </button>

                  <button
                    type="button"
                    onClick={() => savePlacementConfirmation("candidate")}
                    disabled={!canSaveCandidateDocument}
                    style={processButtonStyle(confirmButtonStyle, !canSaveCandidateDocument)}
                  >
                    💾 Bev kandidaat
                  </button>

                  <button
                    type="button"
                    onClick={() => sendPlacementForApproval("customer")}
                    disabled={!canAskCustomerApproval}
                    style={processButtonStyle(successButtonStyle, !canAskCustomerApproval)}
                    title="Plaatsingsbevestiging klant ter akkoord aanbieden via WhatsApp, E-mail of beide"
                  >
                    ✅ Akkoord klant
                  </button>

                  <button
                    type="button"
                    onClick={() => sendPlacementForApproval("candidate")}
                    disabled={!canAskCandidateApproval}
                    style={processButtonStyle(successButtonStyle, !canAskCandidateApproval)}
                    title="Plaatsingsbevestiging kandidaat ter akkoord aanbieden via WhatsApp, E-mail of beide"
                  >
                    ✅ Akk kandidaat
                  </button>

                  <button
                    type="button"
                    onClick={markStarted}
                    disabled={!canStartPlacement}
                    style={processButtonStyle(successButtonStyle, !canStartPlacement)}
                    title="Plaatsing starten"
                  >
                    ▶️ Starten
                  </button>

                  <button
                    type="button"
                    onClick={openPlacementDocumentSets}
                    disabled={!hasSavedPlacement}
                    style={processButtonStyle(documentSetsButtonStyle, !hasSavedPlacement)}
                    title={!hasSavedPlacement ? "Sla de plaatsing eerst op" : "Documentsets voor deze plaatsing"}
                  >
                    📚 Documentsets
                    {documentSetSummary.started
                      ? ` ${documentSetSummary.completed}/${documentSetSummary.total}${documentSetSummary.complete ? " ✓" : ""}`
                      : ""}
                  </button>
                </div>

                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: 8,
                    width: "100%",
                    boxSizing: "border-box",
                  }}
                >
                  <button
                    type="button"
                    onClick={saveItem}
                    disabled={isReadonlyRole || mode !== "form"}
                    style={processButtonStyle(
                      primaryButtonStyle,
                      isReadonlyRole || mode !== "form"
                    )}
                  >
                    💾 Opslaan
                  </button>

                  <button
                    type="button"
                    onClick={deleteItem}
                    disabled={isReadonlyRole || !form.id}
                    style={processButtonStyle(
                      dangerButtonStyle,
                      isReadonlyRole || !form.id
                    )}
                  >
                    🗑 Verwijderen
                  </button>
                </div>

                <div style={{ marginTop: 8, fontSize: 12, color: "#777" }}>
                  Plaatsing-id: {form.id || "(nieuw)"}
                </div>
              </div>
              </>
              )}
              </div>
            </div>
          </div>

          {documentSetsOpen && (form.id || selectedId) && (
            <div
              style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,.35)",
                zIndex: 999997,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 18,
              }}
            >
              <div
                style={{
                  width: "min(900px,100%)",
                  maxHeight: "90vh",
                  overflowY: "auto",
                  background: "white",
                  borderRadius: 12,
                  padding: 18,
                  boxSizing: "border-box",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 12,
                    alignItems: "center",
                    marginBottom: 14,
                  }}
                >
                  <div>
                    <div style={{ fontSize: 20, fontWeight: 700 }}>
                      📚 Documentsets
                    </div>
                    <div style={{ fontSize: 13, opacity: 0.7 }}>
                      {form.placement_number ||
                        [relationName(form), personName(form), form.job_title]
                          .filter(Boolean)
                          .join(" - ")}
                    </div>
                  </div>

                  <button
                    onClick={() => setDocumentSetsOpen(false)}
                    style={buttonStyle}
                  >
                    ✕ Sluiten
                  </button>
                </div>

                {documentSetsError && (
                  <div style={{ color: "crimson", marginBottom: 10 }}>
                    {documentSetsError}
                  </div>
                )}

                {documentSetsBusy && (
                  <div style={{ marginBottom: 10 }}>Bezig...</div>
                )}

                <b>Beschikbare documentsets</b>

                <div style={{ display: "grid", gap: 8, margin: "8px 0 18px" }}>
                  {documentSets.map((set) => {
                    const started = documentSetInstances.some(
                      (x) => String(x.document_set_id) === String(set.id)
                    );

                    return (
                      <div
                        key={set.id}
                        style={{
                          border: "1px solid #ddd",
                          borderRadius: 8,
                          padding: 10,
                          display: "flex",
                          justifyContent: "space-between",
                          gap: 10,
                          alignItems: "center",
                        }}
                      >
                        <div>
                          <b>{set.name}</b>
                          {set.description && (
                            <div style={{ fontSize: 13, opacity: 0.7 }}>
                              {set.description}
                            </div>
                          )}
                          <div style={{ fontSize: 12, opacity: 0.65 }}>
                            {(set.items || []).length} onderdelen
                          </div>
                        </div>

                        <button
                          disabled={started || documentSetsBusy || isReadonlyRole}
                          onClick={() => startPlacementDocumentSet(set.id)}
                          style={
                            started || documentSetsBusy || isReadonlyRole
                              ? buttonDisabledStyle
                              : successButtonStyle
                          }
                        >
                          {started ? "✓ Gestart" : "Start set"}
                        </button>
                      </div>
                    );
                  })}

                  {!documentSets.length && !documentSetsBusy && (
                    <div style={{ fontSize: 13, opacity: 0.7 }}>
                      Geen actieve documentsets voor Plaatsingen.
                    </div>
                  )}
                </div>

                <b>Gestarte documentsets</b>

                <div style={{ display: "grid", gap: 12, marginTop: 8 }}>
                  {documentSetInstances.map((inst) => (
                    <div
                      key={inst.id}
                      style={{
                        border: "1px solid #ddd",
                        borderRadius: 8,
                        padding: 12,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          gap: 8,
                        }}
                      >
                        <b>{inst.document_set_name}</b>
                        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                          <span>
                            {inst.progress_completed || 0}/{inst.progress_total || 0} gereed{" "}
                            {inst.complete ? "✓" : ""}
                          </span>
                          <button
                            type="button"
                            disabled={documentSetsBusy || isReadonlyRole}
                            onClick={() => deletePlacementDocumentSetInstance(inst)}
                            style={
                              documentSetsBusy || isReadonlyRole
                                ? buttonDisabledStyle
                                : dangerButtonStyle
                            }
                            title="Documentset verwijderen; gekoppelde documenten blijven bewaard"
                          >
                            🗑 Verwijder set
                          </button>
                        </div>
                      </div>

                      <div style={{ display: "grid", gap: 7, marginTop: 8 }}>
                        {(inst.items || []).map((item) => {
                          const lookupScope = String(item.lookup_scope || "current").toLowerCase();
                          const sourceDocs =
                            lookupScope === "personnel"
                              ? personnelDocumentsForSet
                              : placementDocuments;

                          const docs = sourceDocs.filter(
                            (d) =>
                              String(d.document_type_id || "") ===
                              String(item.document_type_id || "")
                          );

                          const selectedDocument =
                            [...placementDocuments, ...personnelDocumentsForSet].find(
                              (d) => String(d.id) === String(item.document_id || "")
                            ) || null;

                          const docsWithSelected =
                            selectedDocument &&
                            !docs.some((d) => String(d.id) === String(selectedDocument.id))
                              ? [selectedDocument, ...docs]
                              : docs;

                          return (
                            <div
                              key={item.id}
                              style={{
                                background:
                                  item.required === false &&
                                  !item.document_id &&
                                  item.document_received !== true &&
                                  item.signature_received !== true
                                    ? "#fafafa"
                                    : item.completed
                                      ? "#f2fbf2"
                                      : "#fafafa",
                                border: "1px solid #eee",
                                borderRadius: 6,
                                padding: 8,
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <b>
                                  {item.title || item.document_type_name}
                                  {item.required !== false ? " *" : ""}
                                </b>
                                <span style={{ fontSize: 12 }}>
                                  {item.required === false &&
                                  !item.document_id &&
                                  item.document_received !== true &&
                                  item.signature_received !== true
                                    ? "Optioneel"
                                    : item.completed
                                      ? "✓ Gereed"
                                      : "Open"}
                                </span>
                              </div>

                              {item.description && (
                                <div style={{ fontSize: 12, opacity: 0.7 }}>
                                  {item.description}
                                </div>
                              )}

                              {item.document_required !== false && (
                                <>
                                  <label style={{ fontSize: 12 }}>Document</label>
                                  <select
                                    value={item.document_id || ""}
                                    disabled={isReadonlyRole || documentSetsBusy}
                                    onChange={(e) =>
                                      updatePlacementDocumentSetItem(item, {
                                        document_id: e.target.value
                                          ? Number(e.target.value)
                                          : null,
                                        document_received: !!e.target.value,
                                      })
                                    }
                                    style={selectStyle}
                                  >
                                    <option value="">
                                      (nog niet ontvangen)
                                    </option>
                                    {docsWithSelected.map((d) => (
                                      <option key={d.id} value={d.id}>
                                        {d.title ||
                                          d.file_name ||
                                          `Document ${d.id}`}
                                      </option>
                                    ))}
                                  </select>
                                </>
                              )}

                              {item.signature_required && (
                                <label
                                  style={{
                                    display: "flex",
                                    gap: 7,
                                    alignItems: "center",
                                    fontSize: 12,
                                    marginTop: 5,
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    checked={item.signature_received === true}
                                    disabled={isReadonlyRole || documentSetsBusy}
                                    onChange={(e) =>
                                      updatePlacementDocumentSetItem(item, {
                                        signature_received: e.target.checked,
                                      })
                                    }
                                  />
                                  Ondertekening ontvangen
                                </label>
                              )}

                              {item.document_required !== false && (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    gap: 8,
                                    marginTop: 5,
                                  }}
                                >
                                  <span style={{ fontSize: 12, opacity: 0.7 }}>
                                    Zoeken bij: {lookupScope === "personnel" ? "Personeelsdossier" : "Huidig dossier"}
                                  </span>

                                  {!item.document_id && (
                                    <button
                                      type="button"
                                      disabled={isReadonlyRole || documentSetsBusy}
                                      onClick={() => openDocumentFromPlacementSet(item)}
                                      style={
                                        isReadonlyRole || documentSetsBusy
                                          ? buttonDisabledStyle
                                          : buttonStyle
                                      }
                                    >
                                      + Document toevoegen
                                    </button>
                                  )}
                                </div>
                              )}

                              {item.document_required !== false &&
                                !item.document_id &&
                                !docs.length && (
                                  <div
                                    style={{
                                      fontSize: 12,
                                      color: "#9a6500",
                                      marginTop: 4,
                                    }}
                                  >
                                    Nog geen document van type{" "}
                                    {item.document_type_name || "dit type"} aanwezig.
                                  </div>
                                )}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ))}

                  {!documentSetInstances.length && !documentSetsBusy && (
                    <div style={{ fontSize: 13, opacity: 0.7 }}>
                      Nog geen documentset gestart.
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      );
    }
